// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ApplyHomeDonationEventData, ApplyHomeDonationEventErrors, ApplyHomeDonationEventResponses, ApprovePaymentData, ApprovePaymentErrors, ApprovePaymentResponses, AuthReverseGeocodingData, AuthReverseGeocodingErrors, AuthReverseGeocodingResponses, BeforeCompleteDonationData, BeforeCompleteDonationErrors, BeforeCompleteDonationResponses, BestContentsFeedbackData, BestContentsFeedbackErrors, BestContentsFeedbackResponses, BestContentsWishlistData, BestContentsWishlistErrors, BestContentsWishlistResponses, BlockWelloMemberByCommunityData, BlockWelloMemberByCommunityErrors, BlockWelloMemberByCommunityResponses, CancelOrder1Data, CancelOrder1Errors, CancelOrder1Responses, CancelOrderData, CancelOrderErrors, CancelOrderProductData, CancelOrderProductErrors, CancelOrderProductResponses, CancelOrderProductsData, CancelOrderProductsErrors, CancelOrderProductsResponses, CancelOrderResponses, CancelProductData, CancelProductErrors, CancelProductResponses, CancelReturnData, CancelReturnErrors, CancelReturnResponses, CandidatesData, CandidatesErrors, CandidatesResponses, CertificationCheckData, CertificationCheckErrors, CertificationCheckResponses, CheckDonationAvailableData, CheckDonationAvailableErrors, CheckDonationAvailableResponses, CheckInBenefitAttendanceData, CheckInBenefitAttendanceErrors, CheckInBenefitAttendanceResponses, CheckMemberData, CheckMemberErrors, CheckMemberResponses, CheckoutData, CheckoutErrors, CheckoutResponses, CheckPlusFailData, CheckPlusFailErrors, CheckPlusFailResponses, CheckPlusSendResultData, CheckPlusSendResultErrors, CheckPlusSendResultResponses, CheckVotedData, CheckVotedErrors, CheckVotedResponses, CheckWelloPolicyApplyData, CheckWelloPolicyApplyErrors, CheckWelloPolicyApplyResponses, CompleteDonationData, CompleteDonationErrors, CompleteDonationResponses, ConfirmHouseholdInfoAgreementData, ConfirmHouseholdInfoAgreementErrors, ConfirmHouseholdInfoAgreementResponses, ConfirmOrderProductData, ConfirmOrderProductErrors, ConfirmOrderProductResponses, ConfirmPurchaseData, ConfirmPurchaseErrors, ConfirmPurchaseResponses, CreateBeforeOrderData, CreateBeforeOrderErrors, CreateBeforeOrderResponses, CreateDeliveryAddressData, CreateDeliveryAddressErrors, CreateDeliveryAddressResponses, CreateDonationReservationData, CreateDonationReservationErrors, CreateDonationReservationResponses, CreateMemberData, CreateMemberErrors, CreateMemberResponses, CreatePollVoteData, CreatePollVoteErrors, CreatePollVoteResponses, DecryptMemberVerificationData, DecryptMemberVerificationErrors, DecryptMemberVerificationResponses, DeleteBlocklistData, DeleteBlocklistErrors, DeleteBlocklistResponses, DeleteCartItemData, DeleteCartItemErrors, DeleteCartItemResponses, DeleteCartItemsData, DeleteCartItemsErrors, DeleteCartItemsResponses, DeleteDeliveryAddressData, DeleteDeliveryAddressErrors, DeleteDeliveryAddressResponses, DeleteDonationBusinessCommentData, DeleteDonationBusinessCommentErrors, DeleteDonationBusinessCommentResponses, DeleteHomeInquiryData, DeleteHomeInquiryErrors, DeleteHomeInquiryResponses, DeleteInquiryData, DeleteInquiryErrors, DeleteInquiryResponses, DeleteMemberWelloBlockData, DeleteMemberWelloBlockErrors, DeleteMemberWelloBlockResponses, DeleteMyReviewData, DeleteMyReviewErrors, DeleteMyReviewResponses, DeleteTourReviewData, DeleteTourReviewErrors, DeleteTourReviewResponses, DeleteWelloCommentData, DeleteWelloCommentErrors, DeleteWelloCommentResponses, DeleteWelloLikeData, DeleteWelloLikeErrors, DeleteWelloLikeResponses, DeleteWishlistData, DeleteWishlistErrors, DeleteWishlistResponses, DownloadAllCouponsData, DownloadAllCouponsErrors, DownloadAllCouponsResponses, DownloadCouponData, DownloadCouponErrors, DownloadCouponResponses, DrawNonsanRouletteData, DrawNonsanRouletteErrors, DrawNonsanRouletteResponses, DummyCompleteData, DummyCompleteErrors, DummyCompleteResponses, ExchangeOrderProductsData, ExchangeOrderProductsErrors, ExchangeOrderProductsResponses, ExchangeProductData, ExchangeProductErrors, ExchangeProductResponses, ExistsDownloadableCouponData, ExistsDownloadableCouponErrors, ExistsDownloadableCouponResponses, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsErrors, FeedbackCommunityWelloNewsResponses, FeedbackPointMarketProductData, FeedbackPointMarketProductErrors, FeedbackPointMarketProductResponses, FileCopyData, FileCopyErrors, FileCopyResponses, FileDecryptionDownloadData, FileDecryptionDownloadErrors, FileDecryptionDownloadResponses, FileDeleteData, FileDeleteErrors, FileDeleteResponses, FileRenameData, FileRenameErrors, FileRenameResponses, FileReUploadData, FileReUploadErrors, FileReUploadResponses, FileUpload1Data, FileUpload1Errors, FileUpload1Responses, FileUploadData, FileUploadErrors, FileUploadResponses, FindAffiliatePartnerPointSummaryData, FindAffiliatePartnerPointSummaryErrors, FindAffiliatePartnerPointSummaryResponses, FindAffiliatePartnerPointTransactionListData, FindAffiliatePartnerPointTransactionListErrors, FindAffiliatePartnerPointTransactionListResponses, FindAffiliateWelloPointSummaryData, FindAffiliateWelloPointSummaryErrors, FindAffiliateWelloPointSummaryResponses, FindAllOrdersData, FindAllOrdersErrors, FindAllOrdersResponses, FindAllTermsData, FindAllTermsErrors, FindAllTermsResponses, FindApplicableCouponsData, FindApplicableCouponsErrors, FindApplicableCouponsForProductsData, FindApplicableCouponsForProductsErrors, FindApplicableCouponsForProductsResponses, FindApplicableCouponsResponses, FindArticleFeedbackData, FindArticleFeedbackErrors, FindArticleFeedbackResponses, FindAvailableCouponsData, FindAvailableCouponsErrors, FindAvailableCouponsResponses, FindBenefitAttendanceStatusData, FindBenefitAttendanceStatusErrors, FindBenefitAttendanceStatusResponses, FindBenefitMenuListData, FindBenefitMenuListErrors, FindBenefitMenuListResponses, FindBenefitReadRewardContentListData, FindBenefitReadRewardContentListErrors, FindBenefitReadRewardContentListResponses, FindBenefitReadRewardData, FindBenefitReadRewardErrors, FindBenefitReadRewardResponses, FindBenefitTicketBalanceData, FindBenefitTicketBalanceErrors, FindBenefitTicketBalanceResponses, FindBlocklistData, FindBlocklistErrors, FindBlocklistResponses, FindCartItemsData, FindCartItemsErrors, FindCartItemsResponses, FindCouponAvailableData, FindCouponAvailableErrors, FindCouponAvailableResponses, FindDownloadableCouponsData, FindDownloadableCouponsErrors, FindDownloadableCouponsResponses, FindEventRewardListData, FindEventRewardListErrors, FindEventRewardListResponses, FindHomeInquiryData, FindHomeInquiryErrors, FindHomeInquiryListData, FindHomeInquiryListErrors, FindHomeInquiryListResponses, FindHomeInquiryResponses, FindLotteryEntryAvailabilityData, FindLotteryEntryAvailabilityErrors, FindLotteryEntryAvailabilityResponses, FindLuckyTicketAvailabilityData, FindLuckyTicketAvailabilityErrors, FindLuckyTicketAvailabilityResponses, FindMemberIdentityData, FindMemberIdentityErrors, FindMemberIdentityResponses, FindMyCouponsData, FindMyCouponsErrors, FindMyCouponsResponses, FindMyHomeInquiryListData, FindMyHomeInquiryListErrors, FindMyHomeInquiryListResponses, FindMyReviewData, FindMyReviewErrors, FindMyReviewResponses, FindMyReviewsData, FindMyReviewsErrors, FindMyReviewsResponses, FindNonsanRouletteStatusData, FindNonsanRouletteStatusErrors, FindNonsanRouletteStatusResponses, FindOrderByNumberData, FindOrderByNumberErrors, FindOrderByNumberResponses, FindOrderData, FindOrderErrors, FindOrderResponses, FindPaymentConfigData, FindPaymentConfigErrors, FindPaymentConfigResponses, FindRecentViewSheetAffiliateGiftProductListData, FindRecentViewSheetAffiliateGiftProductListErrors, FindRecentViewSheetAffiliateGiftProductListResponses, FindRouletteBrandListData, FindRouletteBrandListErrors, FindRouletteBrandListResponses, FindRouletteData, FindRouletteErrors, FindRouletteResponses, FindSimplePayMethodsData, FindSimplePayMethodsErrors, FindSimplePayMethodsResponses, FindTermsData, FindTermsErrors, FindTermsResponses, FindTourFeedbackData, FindTourFeedbackErrors, FindTourFeedbackResponses, FindTourReviewData, FindTourReviewErrors, FindTourReviewResponses, FindUnifiedOrdersData, FindUnifiedOrdersErrors, FindUnifiedOrdersResponses, FindUseTabAffiliateGiftProductListData, FindUseTabAffiliateGiftProductListErrors, FindUseTabAffiliateGiftProductListResponses, FindVisitLuckyTicketMerchantListData, FindVisitLuckyTicketMerchantListErrors, FindVisitLuckyTicketMerchantListResponses, GetActionCountData, GetActionCountErrors, GetActionCountResponses, GetBeforeOrderData, GetBeforeOrderErrors, GetBeforeOrderResponses, GetBenefitNotificationApplicationResultsUrlData, GetBenefitNotificationApplicationResultsUrlErrors, GetBenefitNotificationApplicationResultsUrlResponses, GetBenefitNotificationFitAnalysisData, GetBenefitNotificationFitAnalysisErrors, GetBenefitNotificationFitAnalysisResponses, GetBenefitNotificationFitAnalysisResultData, GetBenefitNotificationFitAnalysisResultErrors, GetBenefitNotificationFitAnalysisResultResponses, GetBenefitNotificationMainInfoData, GetBenefitNotificationMainInfoErrors, GetBenefitNotificationMainInfoResponses, GetBenefitNotificationPrivacyUsageUrlData, GetBenefitNotificationPrivacyUsageUrlErrors, GetBenefitNotificationPrivacyUsageUrlResponses, GetBenefitNotificationPrivatePolicyUrlData, GetBenefitNotificationPrivatePolicyUrlErrors, GetBenefitNotificationPrivatePolicyUrlResponses, GetBenefitNotificationPublicServiceDetailUrlData, GetBenefitNotificationPublicServiceDetailUrlErrors, GetBenefitNotificationPublicServiceDetailUrlResponses, GetBenefitNotificationServiceUsageAgreementManagementUrlData, GetBenefitNotificationServiceUsageAgreementManagementUrlErrors, GetBenefitNotificationServiceUsageAgreementManagementUrlResponses, GetBenefitNotificationServiceUsageAgreementUrlData, GetBenefitNotificationServiceUsageAgreementUrlErrors, GetBenefitNotificationServiceUsageAgreementUrlResponses, GetBenefitNotificationSituationManagementUrlData, GetBenefitNotificationSituationManagementUrlErrors, GetBenefitNotificationSituationManagementUrlResponses, GetBenefitNotificationTermServiceUrlData, GetBenefitNotificationTermServiceUrlErrors, GetBenefitNotificationTermServiceUrlResponses, GetCommunityWelloNewsData, GetCommunityWelloNewsErrors, GetCommunityWelloNewsResponses, GetCommunityWelloNewsWishlistData, GetCommunityWelloNewsWishlistErrors, GetCommunityWelloNewsWishlistResponses, GetCoupangBannerStatusData, GetCoupangBannerStatusErrors, GetCoupangBannerStatusResponses, GetDecemberRandomTicketCountData, GetDecemberRandomTicketCountErrors, GetDecemberRandomTicketCountResponses, GetDeliveryAddressData, GetDeliveryAddressErrors, GetDeliveryAddressListData, GetDeliveryAddressListErrors, GetDeliveryAddressListResponses, GetDeliveryAddressResponses, GetDeliveryTracking1Data, GetDeliveryTracking1Errors, GetDeliveryTracking1Responses, GetDeliveryTracking2Data, GetDeliveryTracking2Errors, GetDeliveryTracking2Responses, GetDeliveryTrackingData, GetDeliveryTrackingErrors, GetDeliveryTrackingResponses, GetDetailPointBalanceData, GetDetailPointBalanceErrors, GetDetailPointBalanceResponses, GetDonationBusinessCommentListData, GetDonationBusinessCommentListErrors, GetDonationBusinessCommentListResponses, GetEmergencyRoomData, GetEmergencyRoomErrors, GetEmergencyRoomListData, GetEmergencyRoomListErrors, GetEmergencyRoomListResponses, GetEmergencyRoomResponses, GetEmergencyRoomWishlistData, GetEmergencyRoomWishlistErrors, GetEmergencyRoomWishlistResponses, GetEventHistoryListData, GetEventHistoryListErrors, GetEventHistoryListResponses, GetFeedListData, GetFeedListErrors, GetFeedListResponses, GetGiftOrderHistoryData, GetGiftOrderHistoryErrors, GetGiftOrderHistoryListData, GetGiftOrderHistoryListErrors, GetGiftOrderHistoryListResponses, GetGiftOrderHistoryResponses, GetGiftOrderProductReviewData, GetGiftOrderProductReviewErrors, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListErrors, GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewResponses, GetHomeDonationHistoryData, GetHomeDonationHistoryErrors, GetHomeDonationHistoryListData, GetHomeDonationHistoryListErrors, GetHomeDonationHistoryListResponses, GetHomeDonationHistoryResponses, GetHomeInstitutionCertificateData, GetHomeInstitutionCertificateErrors, GetHomeInstitutionCertificateResponses, GetHomeInstitutionEventListData, GetHomeInstitutionEventListErrors, GetHomeInstitutionEventListResponses, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListErrors, GetHomeInstitutionPolicyListResponses, GetHomeNoticeListData, GetHomeNoticeListErrors, GetHomeNoticeListResponses, GetInquiryData, GetInquiryErrors, GetInquiryResponses, GetInterestPolicyListData, GetInterestPolicyListErrors, GetInterestPolicyListResponses, GetInvitedMemberCountData, GetInvitedMemberCountErrors, GetInvitedMemberCountResponses, GetInviteeEventReceivedData, GetInviteeEventReceivedErrors, GetInviteeEventReceivedResponses, GetLatestCompletedCiData, GetLatestCompletedCiErrors, GetLatestCompletedCiResponses, GetLatestCompletedData, GetLatestCompletedErrors, GetLatestCompletedResponses, GetLatestHomeInstitutionCertificateData, GetLatestHomeInstitutionCertificateErrors, GetLatestHomeInstitutionCertificateResponses, GetListLikeContentsData, GetListLikeContentsErrors, GetListLikeContentsResponses, GetListLikeContentsTypeData, GetListLikeContentsTypeErrors, GetListLikeContentsTypeResponses, GetListPointAttendanceData, GetListPointAttendanceErrors, GetListPointAttendanceResponses, GetListPointHistoryData, GetListPointHistoryErrors, GetListPointHistoryResponses, GetLiveWelloCommentListData, GetLiveWelloCommentListErrors, GetLiveWelloCommentListResponses, GetLocalfestaParticipantInfoData, GetLocalfestaParticipantInfoErrors, GetLocalfestaParticipantInfoResponses, GetLocationServiceConsentData, GetLocationServiceConsentErrors, GetLocationServiceConsentResponses, GetMemberData, GetMemberDetailInfoData, GetMemberDetailInfoErrors, GetMemberDetailInfoResponses, GetMemberErrors, GetMemberResponses, GetMemberTermAgreementByAgreementTypeData, GetMemberTermAgreementByAgreementTypeErrors, GetMemberTermAgreementByAgreementTypeResponses, GetMemberVerificationIdData, GetMemberVerificationIdErrors, GetMemberVerificationIdResponses, GetMetaPolicyCommentListData, GetMetaPolicyCommentListErrors, GetMetaPolicyCommentListResponses, GetMyDonationInfoData, GetMyDonationInfoErrors, GetMyDonationInfoResponses, GetMyGiftOrderProductReviewListData, GetMyGiftOrderProductReviewListErrors, GetMyGiftOrderProductReviewListResponses, GetMyInviteEventHistorySummaryData, GetMyInviteEventHistorySummaryErrors, GetMyInviteEventHistorySummaryResponses, GetMyWelloCommentListData, GetMyWelloCommentListErrors, GetMyWelloCommentListResponses, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListErrors, GetOrderedHomeInstitutionEventListResponses, GetOrderItemsForActionData, GetOrderItemsForActionErrors, GetOrderItemsForActionResponses, GetPointMarketOrderListData, GetPointMarketOrderListErrors, GetPointMarketOrderListResponses, GetPointMarketOrderPreviewData, GetPointMarketOrderPreviewErrors, GetPointMarketOrderPreviewResponses, GetPollData, GetPollErrors, GetPollResponses, GetPollResultData, GetPollResultErrors, GetPollResultResponses, GetPrimaryDeliveryAddressData, GetPrimaryDeliveryAddressErrors, GetPrimaryDeliveryAddressResponses, GetPrivateDataConsentData, GetPrivateDataConsentErrors, GetPrivateDataConsentResponses, GetProductOptionsByIdData, GetProductOptionsByIdErrors, GetProductOptionsByIdResponses, GetProductRefundInfoData, GetProductRefundInfoErrors, GetProductRefundInfoResponses, GetReceiptData, GetReceiptErrors, GetReceiptResponses, GetRefundEstimateData, GetRefundEstimateErrors, GetRefundEstimateResponses, GetRefundInfoData, GetRefundInfoErrors, GetRefundInfoResponses, GetReviewFormData, GetReviewFormErrors, GetReviewFormResponses, GetTourFestivalWishlistData, GetTourFestivalWishlistErrors, GetTourFestivalWishlistResponses, GetTransactionStatementData, GetTransactionStatementErrors, GetTransactionStatementResponses, GetWebWelloAppPushListData, GetWebWelloAppPushListErrors, GetWebWelloAppPushListResponses, GetWelloCommentListData, GetWelloCommentListErrors, GetWelloCommentListResponses, GetWelloMemberBlockListData, GetWelloMemberBlockListErrors, GetWelloMemberBlockListResponses, GetWelloPolicyApplyCountData, GetWelloPolicyApplyCountErrors, GetWelloPolicyApplyCountResponses, GetWelloPolicyApplyListData, GetWelloPolicyApplyListErrors, GetWelloPolicyApplyListResponses, HometownNewsData, HometownNewsErrors, HometownNewsFeedbackData, HometownNewsFeedbackErrors, HometownNewsFeedbackResponses, HometownNewsResponses, HometownNewsWishlistData, HometownNewsWishlistErrors, HometownNewsWishlistResponses, InquiryListData, InquiryListErrors, InquiryListResponses, InterestFilterData, InterestFilterErrors, InterestFilterResponses, IsEventInProgressData, IsEventInProgressErrors, IsEventInProgressResponses, IssuePointMarketCouponData, IssuePointMarketCouponErrors, IssuePointMarketCouponResponses, KbMemberCheckData, KbMemberCheckErrors, KbMemberCheckResponses, LatestCompleteDonationData, LatestCompleteDonationErrors, LatestCompleteDonationResponses, LogoutMemberData, LogoutMemberErrors, LogoutMemberResponses, MemberContentCountData, MemberContentCountErrors, MemberContentCountResponses, MemberData, MemberErrors, MemberNeighborPolicyListData, MemberNeighborPolicyListErrors, MemberNeighborPolicyListResponses, MemberPeerGroupPolicyListData, MemberPeerGroupPolicyListErrors, MemberPeerGroupPolicyListResponses, MemberPolicyListData, MemberPolicyListErrors, MemberPolicyListResponses, MemberRecommendPolicyByRecentListData, MemberRecommendPolicyByRecentListErrors, MemberRecommendPolicyByRecentListResponses, MemberResponses, MemberSocialAccountsData, MemberSocialAccountsErrors, MemberSocialAccountsResponses, MergeData, MergeErrors, MergeResponses, MessageReceiveData, MessageReceiveErrors, MessageReceiveResponses, MetaPolicyFeedbackData, MetaPolicyFeedbackErrors, MetaPolicyFeedbackResponses, MetaPolicyWishlistData, MetaPolicyWishlistErrors, MetaPolicyWishlistResponses, NoticeListData, NoticeListErrors, NoticeListResponses, OpenRandomTicketData, OpenRandomTicketErrors, OpenRandomTicketResponses, PayPointMarketOrderData, PayPointMarketOrderErrors, PayPointMarketOrderResponses, ProcessDonationData, ProcessDonationErrors, ProcessDonationResponses, PutFitFilterData, PutFitFilterErrors, PutFitFilterResponses, RecommendPolicyListData, RecommendPolicyListErrors, RecommendPolicyListResponses, ReissueCouponData, ReissueCouponErrors, ReissueCouponResponses, RejectMessageData, RejectMessageErrors, RejectMessageResponses, RemoveGiftOrderProductReviewData, RemoveGiftOrderProductReviewErrors, RemoveGiftOrderProductReviewResponses, ReportCommunityData, ReportCommunityErrors, ReportCommunityResponses, RequestReturnData, RequestReturnErrors, RequestReturnResponses, RequiredFilterData, RequiredFilterErrors, RequiredFilterResponses, ResignMember1Data, ResignMember1Errors, ResignMember1Responses, ResignMemberData, ResignMemberErrors, ResignMemberResponses, ReturnOrderProductsData, ReturnOrderProductsErrors, ReturnOrderProductsResponses, ReturnProductData, ReturnProductErrors, ReturnProductResponses, RewardCoupangBannerClickData, RewardCoupangBannerClickErrors, RewardCoupangBannerClickResponses, RewardCpcClickData, RewardCpcClickErrors, RewardCpcClickResponses, RunMerchantSyncData, RunMerchantSyncErrors, RunMerchantSyncResponses, SaveAdpopcornSspHistoryData, SaveAdpopcornSspHistoryErrors, SaveAdpopcornSspHistoryResponses, SaveAffiliateClickData, SaveAffiliateClickErrors, SaveAffiliateClickResponses, SaveAffiliateGiftProductLinkClickData, SaveAffiliateGiftProductLinkClickErrors, SaveAffiliateGiftProductLinkClickResponses, SaveAffiliateHotDealClickData, SaveAffiliateHotDealClickErrors, SaveAffiliateHotDealClickResponses, SaveBenefitNotificationApplicationInfoData, SaveBenefitNotificationApplicationInfoErrors, SaveBenefitNotificationApplicationInfoResponses, SaveBenefitReadRewardData, SaveBenefitReadRewardErrors, SaveBenefitReadRewardResponses, SaveBlocklistData, SaveBlocklistErrors, SaveBlocklistResponses, SaveCartItemData, SaveCartItemErrors, SaveCartItemResponses, SaveDonationBusinessCommentData, SaveDonationBusinessCommentErrors, SaveDonationBusinessCommentResponses, SaveFitFilterData, SaveFitFilterErrors, SaveFitFilterResponses, SaveGiftOrderProductReviewData, SaveGiftOrderProductReviewErrors, SaveGiftOrderProductReviewResponses, SaveGiftProductRecentViewData, SaveGiftProductRecentViewErrors, SaveGiftProductRecentViewResponses, SaveHomeInquiryData, SaveHomeInquiryErrors, SaveHomeInquiryResponses, SaveInquiry1Data, SaveInquiry1Errors, SaveInquiry1Responses, SaveInquiryData, SaveInquiryErrors, SaveInquiryResponses, SaveInterestFilterData, SaveInterestFilterErrors, SaveInterestFilterResponses, SaveKbFilterData, SaveKbFilterErrors, SaveKbFilterResponses, SaveLocalfestaParticipantData, SaveLocalfestaParticipantErrors, SaveLocalfestaParticipantResponses, SaveMemberNickNameData, SaveMemberNickNameErrors, SaveMemberNickNameResponses, SaveOrUpdateMemberTermAgreementData, SaveOrUpdateMemberTermAgreementErrors, SaveOrUpdateMemberTermAgreementResponses, SaveReportData, SaveReportErrors, SaveReportResponses, SaveReviewData, SaveReviewErrors, SaveReviewResponses, SaveRouletteEntryData, SaveRouletteEntryErrors, SaveRouletteEntryResponses, SaveRouletteRetryData, SaveRouletteRetryErrors, SaveRouletteRetryResponses, SaveTodayAttendanceData, SaveTodayAttendanceErrors, SaveTodayAttendanceResponses, SaveTourReviewData, SaveTourReviewErrors, SaveTourReviewResponses, SaveWelloCommentData, SaveWelloCommentErrors, SaveWelloCommentReportData, SaveWelloCommentReportErrors, SaveWelloCommentReportResponses, SaveWelloCommentResponses, SaveWelloDeviceInfoData, SaveWelloDeviceInfoErrors, SaveWelloDeviceInfoResponses, SaveWelloLikeData, SaveWelloLikeErrors, SaveWelloLikeResponses, SaveWelloTrackingData, SaveWelloTrackingErrors, SaveWelloTrackingResponses, SaveWishlistData, SaveWishlistErrors, SaveWishlistResponses, SendCertificationCellphoneData, SendCertificationCellphoneErrors, SendCertificationCellphoneResponses, SendNiceSafeKeyData, SendNiceSafeKeyErrors, SendNiceSafeKeyResponses, SendPinkeyData, SendPinkeyErrors, SendPinkeyResponses, UpdateAllDeliveryAddressData, UpdateAllDeliveryAddressErrors, UpdateAllDeliveryAddressResponses, UpdateDeliveryAddressData, UpdateDeliveryAddressErrors, UpdateDeliveryAddressResponses, UpdateDonationBusinessCommentData, UpdateDonationBusinessCommentErrors, UpdateDonationBusinessCommentResponses, UpdateFileTempSaveYnData, UpdateFileTempSaveYnErrors, UpdateFileTempSaveYnResponses, UpdateGiftOrderAddressData, UpdateGiftOrderAddressErrors, UpdateGiftOrderAddressResponses, UpdateGiftOrderProductReviewData, UpdateGiftOrderProductReviewErrors, UpdateGiftOrderProductReviewResponses, UpdateGiftOrderStatusData, UpdateGiftOrderStatusErrors, UpdateGiftOrderStatusResponses, UpdateHomeInquiryData, UpdateHomeInquiryErrors, UpdateHomeInquiryResponses, UpdateLocalfestaParticipantEntryData, UpdateLocalfestaParticipantEntryErrors, UpdateLocalfestaParticipantEntryResponses, UpdateLocationServiceConsentData, UpdateLocationServiceConsentErrors, UpdateLocationServiceConsentResponses, UpdateMemberNickNameData, UpdateMemberNickNameErrors, UpdateMemberNickNameResponses, UpdateMemberVerificationData, UpdateMemberVerificationErrors, UpdateMemberVerificationResponses, UpdateMyReviewData, UpdateMyReviewErrors, UpdateMyReviewResponses, UpdateOptionData, UpdateOptionErrors, UpdateOptionResponses, UpdatePointMarketOrderStatusListData, UpdatePointMarketOrderStatusListErrors, UpdatePointMarketOrderStatusListResponses, UpdatePrivateDataConsentData, UpdatePrivateDataConsentErrors, UpdatePrivateDataConsentResponses, UpdateQuantityData, UpdateQuantityErrors, UpdateQuantityResponses, UpdateTourReviewData, UpdateTourReviewErrors, UpdateTourReviewResponses, UpdateVendorDeliveryAddressData, UpdateVendorDeliveryAddressErrors, UpdateVendorDeliveryAddressResponses, UpdateWelloAppPushReadData, UpdateWelloAppPushReadErrors, UpdateWelloAppPushReadResponses, UpdateWelloCommentData, UpdateWelloCommentErrors, UpdateWelloCommentResponses, UserPropertyData, UserPropertyErrors, UserPropertyResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * 제휴몰 클릭 발급
 *
 * 제휴몰 내부 식별자와 진입 경로로 클릭 1건을 생성하고, u_id 가 담긴 제휴사 이동 URL을 반환합니다.
 */
export const saveAffiliateClick = <ThrowOnError extends boolean = false>(options: Options<SaveAffiliateClickData, ThrowOnError>): RequestResult<SaveAffiliateClickResponses, SaveAffiliateClickErrors, ThrowOnError> => (options.client ?? client).post<SaveAffiliateClickResponses, SaveAffiliateClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/clicks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 답례품 판매 링크 클릭 발급
 *
 * 답례품 카드의 판매 링크 ID 로 클릭 1건을 생성하고, u_id 가 담긴 상품 페이지 이동 URL을 반환합니다. 노출이 꺼졌거나 생성에 실패한 링크, 노출 대상이 아닌 제휴몰은 returnCode 30404 를 반환합니다.
 */
export const saveAffiliateGiftProductLinkClick = <ThrowOnError extends boolean = false>(options: Options<SaveAffiliateGiftProductLinkClickData, ThrowOnError>): RequestResult<SaveAffiliateGiftProductLinkClickResponses, SaveAffiliateGiftProductLinkClickErrors, ThrowOnError> => (options.client ?? client).post<SaveAffiliateGiftProductLinkClickResponses, SaveAffiliateGiftProductLinkClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/clicks/gift-product-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지금 핫딜 클릭 발급
 *
 * 핫딜 카드 ID 로 클릭 1건을 생성하고, u_id 가 담긴 상품 페이지 이동 URL을 반환합니다. 제휴사에서 사라졌거나 운영자가 내린 카드, 노출 대상이 아닌 제휴몰은 returnCode 30404 를 반환합니다.
 */
export const saveAffiliateHotDealClick = <ThrowOnError extends boolean = false>(options: Options<SaveAffiliateHotDealClickData, ThrowOnError>): RequestResult<SaveAffiliateHotDealClickResponses, SaveAffiliateHotDealClickErrors, ThrowOnError> => (options.client ?? client).post<SaveAffiliateHotDealClickResponses, SaveAffiliateHotDealClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/clicks/hot-deals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 최근 본 답례품 시트 목록 조회
 *
 * 기부 완료 · 고향사랑기부 홈 나가기에서 쓰는 목록이다. 회원이 본 답례품 중 제휴몰 링크가 걸린 것만 최신순으로 나온다. 조회 이력이 없으면 빈 목록이 정상이다 — 어드민에서 켜도 이력과 교집합일 때만 뜬다.
 */
export const findRecentViewSheetAffiliateGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<FindRecentViewSheetAffiliateGiftProductListData, ThrowOnError>): RequestResult<FindRecentViewSheetAffiliateGiftProductListResponses, FindRecentViewSheetAffiliateGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindRecentViewSheetAffiliateGiftProductListResponses, FindRecentViewSheetAffiliateGiftProductListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/gift-products/recent-view-sheet',
    ...options
});

/**
 * 사용하기 탭 제휴사 상품 목록 조회(로그인)
 *
 * 로그인 회원용. 회원이 최근 본 답례품의 카드를 먼저(최근 본 순) 보여주고, 모자라면 나머지를 섞어 채운다. 규칙은 비로그인 /allows/ 쪽과 같고 최근 본 답례품 우선만 다르다. 비로그인은 /allows/ 쪽을 쓴다.
 */
export const findUseTabAffiliateGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<FindUseTabAffiliateGiftProductListData, ThrowOnError>): RequestResult<FindUseTabAffiliateGiftProductListResponses, FindUseTabAffiliateGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindUseTabAffiliateGiftProductListResponses, FindUseTabAffiliateGiftProductListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/gift-products/use-tab',
    ...options
});

/**
 * 제휴몰 수동 동기화
 *
 * 링크프라이스 제휴몰 목록을 지금 동기화합니다(비밀번호는 body 의 password). 정기 동기화(00:45)와 같은 락을 써서 다른 실행 중이면 건너뜁니다(executedYN=false). 몰 수와 걸린 시간을 돌려줍니다. 정기 동기화 시각 앞뒤 15분은 피해서 부르세요.
 */
export const runMerchantSync = <ThrowOnError extends boolean = false>(options: Options<RunMerchantSyncData, ThrowOnError>): RequestResult<RunMerchantSyncResponses, RunMerchantSyncErrors, ThrowOnError> => (options.client ?? client).post<RunMerchantSyncResponses, RunMerchantSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/merchant-sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 방문 행운권 대상 몰 목록 조회
 *
 * 제휴몰로 이동하면 행운권을 받을 수 있는 몰을 운영자 정렬순서로 조회합니다. 몰별 쿨다운(nextAvailableAt)과 회원 일일 상한(dailyCapReachedYN)은 축이 달라 따로 내려갑니다. 기능이 꺼져 있거나 운영자가 켠 몰이 없으면 빈 목록이 정상입니다.
 */
export const findVisitLuckyTicketMerchantList = <ThrowOnError extends boolean = false>(options?: Options<FindVisitLuckyTicketMerchantListData, ThrowOnError>): RequestResult<FindVisitLuckyTicketMerchantListResponses, FindVisitLuckyTicketMerchantListErrors, ThrowOnError> => (options?.client ?? client).get<FindVisitLuckyTicketMerchantListResponses, FindVisitLuckyTicketMerchantListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/merchants/lucky-ticket',
    ...options
});

/**
 * 룰렛 브랜드 목록 조회
 *
 * 노출 중인 룰렛 브랜드를 운영자 지정 순서로 조회합니다. categoryType 을 비우면 「전체」 탭입니다.
 */
export const findRouletteBrandList = <ThrowOnError extends boolean = false>(options?: Options<FindRouletteBrandListData, ThrowOnError>): RequestResult<FindRouletteBrandListResponses, FindRouletteBrandListErrors, ThrowOnError> => (options?.client ?? client).get<FindRouletteBrandListResponses, FindRouletteBrandListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/roulettes',
    ...options
});

/**
 * 룰렛 참여
 *
 * 제휴포인트를 차감하고 첫 판을 돌립니다. 🔴 clientRequestKey 는 화면이 만든 멱등키입니다 — 응답이 유실돼 재시도할 때는 반드시 같은 값을 보내십시오. 새 키로 보내면 정당한 두 번째 참여로 접수돼 포인트가 한 번 더 빠집니다.
 */
export const saveRouletteEntry = <ThrowOnError extends boolean = false>(options: Options<SaveRouletteEntryData, ThrowOnError>): RequestResult<SaveRouletteEntryResponses, SaveRouletteEntryErrors, ThrowOnError> => (options.client ?? client).post<SaveRouletteEntryResponses, SaveRouletteEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/roulettes/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 룰렛 재도전
 *
 * 포인트를 쓰지 않고 한 번 더 돌립니다. 참여당 최대 2회 — 첫 재도전은 무료, 두 번째는 광고 시청 후입니다(직전 응답의 nextRetryType). 광고 재도전은 리워드 비디오 시청 이력 ID 를 body 에 넣습니다 — 없거나 직전 회차보다 먼저 저장된 이력이면 30400. 재도전 기한(retryDeadlineAt = 재도전권 발급 후 24시간)이 지나면 30400 「재도전 기한이 지났어요」. body 의 clientRequestKey(선택)를 같은 값으로 다시 보내면 다시 돌리지 않고 직전 결과를 200 으로 줍니다(응답 유실 재시도).
 */
export const saveRouletteRetry = <ThrowOnError extends boolean = false>(options: Options<SaveRouletteRetryData, ThrowOnError>): RequestResult<SaveRouletteRetryResponses, SaveRouletteRetryErrors, ThrowOnError> => (options.client ?? client).post<SaveRouletteRetryResponses, SaveRouletteRetryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/roulettes/entries/{rouletteEntryId}/retries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 룰렛 화면 조회
 *
 * 칸 목록과 참여 조건(참여 비용·잔액)을 조회합니다. 🔴 당첨 확률(가중치)은 내려보내지 않습니다.
 *
 * 읽기 전용입니다 — 화면에 다시 들어와도 남은 재도전은 사라지지 않습니다. 기한 안에 이어 돌릴 수 있는 진행 중 참여가 있으면 inProgressEntry 로 내려가니, 그 rouletteEntryId 로 재도전을 이어 부르십시오. 같은 룰렛에 새로 참여(유료)하면 이전 진행 중 참여는 미당첨으로 확정됩니다.
 */
export const findRoulette = <ThrowOnError extends boolean = false>(options: Options<FindRouletteData, ThrowOnError>): RequestResult<FindRouletteResponses, FindRouletteErrors, ThrowOnError> => (options.client ?? client).get<FindRouletteResponses, FindRouletteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/roulettes/{rouletteBrandId}',
    ...options
});

/**
 * 제휴포인트 요약 조회
 *
 * 잔액, 아직 회수되지 않은 금액, 적립 예정 금액을 조회합니다. 한 번도 적립하지 않은 회원은 모두 0 입니다.
 */
export const findAffiliatePartnerPointSummary = <ThrowOnError extends boolean = false>(options?: Options<FindAffiliatePartnerPointSummaryData, ThrowOnError>): RequestResult<FindAffiliatePartnerPointSummaryResponses, FindAffiliatePartnerPointSummaryErrors, ThrowOnError> => (options?.client ?? client).get<FindAffiliatePartnerPointSummaryResponses, FindAffiliatePartnerPointSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/summary',
    ...options
});

/**
 * 제휴포인트 내역 조회
 *
 * 제휴포인트 내역을 최신순 커서 페이징으로 조회합니다. 첫 페이지는 lastTransactionId 를 비우고, 이후에는 직전 응답의 lastTransactionId 를 그대로 넣습니다. transactionFilterType 으로 화면의 칩 5개(ALL·ACCRUE·USE·DEDUCT·EXPIRE)를 거릅니다 — 어떤 내역 종류가 어느 칩에 드는지는 서버가 정하므로 화면이 종류를 직접 묶지 마십시오. 🔴 칩을 바꿀 때는 lastTransactionId 를 비우고 첫 페이지부터 다시 부르십시오.
 */
export const findAffiliatePartnerPointTransactionList = <ThrowOnError extends boolean = false>(options?: Options<FindAffiliatePartnerPointTransactionListData, ThrowOnError>): RequestResult<FindAffiliatePartnerPointTransactionListResponses, FindAffiliatePartnerPointTransactionListErrors, ThrowOnError> => (options?.client ?? client).get<FindAffiliatePartnerPointTransactionListResponses, FindAffiliatePartnerPointTransactionListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/partner-points/transactions',
    ...options
});

/**
 * 쇼핑적립 웰포인트 요약 조회
 *
 * 쇼핑적립 실적은 잡혔지만 아직 지급되지 않은 웰포인트 금액을 조회합니다. 혜택홈과 웰포인트 탭이 같은 값을 씁니다. 한 번도 적립하지 않은 회원은 0 입니다. 🔴 웰포인트 잔액은 이 응답에 없습니다 — 기존 포인트 조회를 쓰십시오.
 */
export const findAffiliateWelloPointSummary = <ThrowOnError extends boolean = false>(options?: Options<FindAffiliateWelloPointSummaryData, ThrowOnError>): RequestResult<FindAffiliateWelloPointSummaryResponses, FindAffiliateWelloPointSummaryErrors, ThrowOnError> => (options?.client ?? client).get<FindAffiliateWelloPointSummaryResponses, FindAffiliateWelloPointSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/affiliate/wello-points/summary',
    ...options
});

/**
 * 최근 본 답례품 기록
 *
 * 로그인 회원의 답례품 조회 이력을 남긴다. 같은 답례품을 여러 번 봐도 한 행이고 본 시각만 갱신된다. 🔴 조회수는 세지 않는다 — 조회수 증가는 비로그인 경로(/wello/v2/allows/home-love-view)가 담당하며, 두 경로를 모두 호출해야 조회수와 이력이 각각 정상으로 남는다.
 */
export const saveGiftProductRecentView = <ThrowOnError extends boolean = false>(options: Options<SaveGiftProductRecentViewData, ThrowOnError>): RequestResult<SaveGiftProductRecentViewResponses, SaveGiftProductRecentViewErrors, ThrowOnError> => (options.client ?? client).post<SaveGiftProductRecentViewResponses, SaveGiftProductRecentViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/gift-products/{productNumber}/recent-view',
    ...options
});

/**
 * 투어 조회수/스크랩 정보 조회 (로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedback = <ThrowOnError extends boolean = false>(options: Options<FindArticleFeedbackData, ThrowOnError>): RequestResult<FindArticleFeedbackResponses, FindArticleFeedbackErrors, ThrowOnError> => (options.client ?? client).get<FindArticleFeedbackResponses, FindArticleFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/tour/article/{articleId}/feedback',
    ...options
});

/**
 * 축제 리뷰 작성
 *
 * 인증된 회원이 축제에 대한 리뷰를 작성합니다.
 */
export const saveTourReview = <ThrowOnError extends boolean = false>(options: Options<SaveTourReviewData, ThrowOnError>): RequestResult<SaveTourReviewResponses, SaveTourReviewErrors, ThrowOnError> => (options.client ?? client).post<SaveTourReviewResponses, SaveTourReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/tour/festival/{tourId}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 축제 리뷰 삭제
 *
 * 본인이 작성한 축제 리뷰를 소프트 삭제합니다.
 */
export const deleteTourReview = <ThrowOnError extends boolean = false>(options: Options<DeleteTourReviewData, ThrowOnError>): RequestResult<DeleteTourReviewResponses, DeleteTourReviewErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTourReviewResponses, DeleteTourReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}',
    ...options
});

/**
 * 축제 리뷰 단건 조회
 *
 * 본인이 작성한 축제 리뷰를 단건 조회합니다.
 */
export const findTourReview = <ThrowOnError extends boolean = false>(options: Options<FindTourReviewData, ThrowOnError>): RequestResult<FindTourReviewResponses, FindTourReviewErrors, ThrowOnError> => (options.client ?? client).get<FindTourReviewResponses, FindTourReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}',
    ...options
});

/**
 * 축제 리뷰 수정
 *
 * 본인이 작성한 축제 리뷰를 전체 교체합니다.
 */
export const updateTourReview = <ThrowOnError extends boolean = false>(options: Options<UpdateTourReviewData, ThrowOnError>): RequestResult<UpdateTourReviewResponses, UpdateTourReviewErrors, ThrowOnError> => (options.client ?? client).put<UpdateTourReviewResponses, UpdateTourReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 출석 현황 조회
 *
 * 7일 순환 출석 캘린더 상태와 오늘 체크인 시 지급될 행운권 수를 반환합니다.
 */
export const findBenefitAttendanceStatus = <ThrowOnError extends boolean = false>(options?: Options<FindBenefitAttendanceStatusData, ThrowOnError>): RequestResult<FindBenefitAttendanceStatusResponses, FindBenefitAttendanceStatusErrors, ThrowOnError> => (options?.client ?? client).get<FindBenefitAttendanceStatusResponses, FindBenefitAttendanceStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-attendance',
    ...options
});

/**
 * 출석체크 실행
 *
 * 오늘 출석을 기록하고 행운권(+동수 응모권)을 지급합니다. 만 19세 이상만 가능합니다.
 */
export const checkInBenefitAttendance = <ThrowOnError extends boolean = false>(options?: Options<CheckInBenefitAttendanceData, ThrowOnError>): RequestResult<CheckInBenefitAttendanceResponses, CheckInBenefitAttendanceErrors, ThrowOnError> => (options?.client ?? client).post<CheckInBenefitAttendanceResponses, CheckInBenefitAttendanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-attendance',
    ...options
});

/**
 * 로또 응모 가능 여부 조회
 *
 * 응모권 보유량, 응모 비용(5), 피버 여부, 응모 가능 여부(피버 && 응모권 충분)를 반환합니다.
 */
export const findLotteryEntryAvailability = <ThrowOnError extends boolean = false>(options?: Options<FindLotteryEntryAvailabilityData, ThrowOnError>): RequestResult<FindLotteryEntryAvailabilityResponses, FindLotteryEntryAvailabilityErrors, ThrowOnError> => (options?.client ?? client).get<FindLotteryEntryAvailabilityResponses, FindLotteryEntryAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-lottery/entry-availability',
    ...options
});

/**
 * 혜택 메뉴 목록 조회 (로그인)
 *
 * 비로그인 목록(/wello/v2/allows/benefit-menus)과 같은 응답에 CPC 메뉴의 참여(지급) 완료 여부(participatedYN)를 채웁니다. allows 경로는 토큰을 해석하지 않으므로 로그인 상태에서는 이 API 를 호출합니다.
 */
export const findBenefitMenuList = <ThrowOnError extends boolean = false>(options?: Options<FindBenefitMenuListData, ThrowOnError>): RequestResult<FindBenefitMenuListResponses, FindBenefitMenuListErrors, ThrowOnError> => (options?.client ?? client).get<FindBenefitMenuListResponses, FindBenefitMenuListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-menus',
    ...options
});

/**
 * 혜택 메뉴 CPC 클릭 지급
 *
 * CPC 메뉴 클릭 시 메뉴에 설정된 웰포인트를 지급합니다(1인 1회). 지급할 수 없으면 returnCode 30400 과 사유 메시지를 반환합니다 — 노출 기간이 아니거나 CPC 메뉴가 아님 · 이미 참여 완료 · 예산 소진 · 적립 실패. 메뉴가 없으면 30404.
 */
export const rewardCpcClick = <ThrowOnError extends boolean = false>(options: Options<RewardCpcClickData, ThrowOnError>): RequestResult<RewardCpcClickResponses, RewardCpcClickErrors, ThrowOnError> => (options.client ?? client).post<RewardCpcClickResponses, RewardCpcClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-menus/{benefitMenuId}/cpc-click',
    ...options
});

/**
 * 혜택 알리미 - 신청 정보 저장
 */
export const saveBenefitNotificationApplicationInfo = <ThrowOnError extends boolean = false>(options: Options<SaveBenefitNotificationApplicationInfoData, ThrowOnError>): RequestResult<SaveBenefitNotificationApplicationInfoResponses, SaveBenefitNotificationApplicationInfoErrors, ThrowOnError> => (options.client ?? client).post<SaveBenefitNotificationApplicationInfoResponses, SaveBenefitNotificationApplicationInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/application-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 혜택 알리미 - 신청 결과 목록 화면 URL 조회
 */
export const getBenefitNotificationApplicationResultsUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationApplicationResultsUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationApplicationResultsUrlResponses, GetBenefitNotificationApplicationResultsUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationApplicationResultsUrlResponses, GetBenefitNotificationApplicationResultsUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/application-results-url',
    ...options
});

/**
 * 혜택 알리미 - 6. 맞춤 분석 요청
 */
export const getBenefitNotificationFitAnalysis = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationFitAnalysisData, ThrowOnError>): RequestResult<GetBenefitNotificationFitAnalysisResponses, GetBenefitNotificationFitAnalysisErrors, ThrowOnError> => (options?.client ?? client).get<GetBenefitNotificationFitAnalysisResponses, GetBenefitNotificationFitAnalysisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/fit-analysis',
    ...options
});

/**
 * 혜택 알리미 - 맞춤 맞춤분석 요청 및 결과 조회
 */
export const getBenefitNotificationFitAnalysisResult = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationFitAnalysisResultData, ThrowOnError>): RequestResult<GetBenefitNotificationFitAnalysisResultResponses, GetBenefitNotificationFitAnalysisResultErrors, ThrowOnError> => (options?.client ?? client).get<GetBenefitNotificationFitAnalysisResultResponses, GetBenefitNotificationFitAnalysisResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/fit-analysis-result',
    ...options
});

/**
 * 혜택 알리미 - 2. 혜택알리미 메인 정보 조회
 */
export const getBenefitNotificationMainInfo = <ThrowOnError extends boolean = false>(options?: Options<GetBenefitNotificationMainInfoData, ThrowOnError>): RequestResult<GetBenefitNotificationMainInfoResponses, GetBenefitNotificationMainInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetBenefitNotificationMainInfoResponses, GetBenefitNotificationMainInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/main-info',
    ...options
});

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 개인정보 처리방침
 */
export const getBenefitNotificationPrivatePolicyUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPrivatePolicyUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationPrivatePolicyUrlResponses, GetBenefitNotificationPrivatePolicyUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationPrivatePolicyUrlResponses, GetBenefitNotificationPrivatePolicyUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/privacy-policy-url',
    ...options
});

/**
 * 혜택알리미 - 17. 개인정보 활용이력 화면 URL 조회
 */
export const getBenefitNotificationPrivacyUsageUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPrivacyUsageUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationPrivacyUsageUrlResponses, GetBenefitNotificationPrivacyUsageUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationPrivacyUsageUrlResponses, GetBenefitNotificationPrivacyUsageUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/privacy-usage-url',
    ...options
});

/**
 * 혜택 알리미 - 공공서비스 상세 화면 URL 조회
 */
export const getBenefitNotificationPublicServiceDetailUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationPublicServiceDetailUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationPublicServiceDetailUrlResponses, GetBenefitNotificationPublicServiceDetailUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationPublicServiceDetailUrlResponses, GetBenefitNotificationPublicServiceDetailUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/public-service-detail-url',
    ...options
});

/**
 * 혜택알리미 - 16. 서비스 이용 동의 관리 화면 URL 조회 (서비스 이용동의/철회)
 */
export const getBenefitNotificationServiceUsageAgreementManagementUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationServiceUsageAgreementManagementUrlResponses, GetBenefitNotificationServiceUsageAgreementManagementUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationServiceUsageAgreementManagementUrlResponses, GetBenefitNotificationServiceUsageAgreementManagementUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/service-usage-agreement-management-url',
    ...options
});

/**
 * 혜택 알리미 - 1. 서비스 이용 동의 화면 URL 조회
 */
export const getBenefitNotificationServiceUsageAgreementUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationServiceUsageAgreementUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationServiceUsageAgreementUrlResponses, GetBenefitNotificationServiceUsageAgreementUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationServiceUsageAgreementUrlResponses, GetBenefitNotificationServiceUsageAgreementUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/service-usage-agreement-url',
    ...options
});

/**
 * 혜택알리미 - 13. 상황 인지데이터 화면 URL 조회(현재 상황 설정 화면 url)
 */
export const getBenefitNotificationSituationManagementUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationSituationManagementUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationSituationManagementUrlResponses, GetBenefitNotificationSituationManagementUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationSituationManagementUrlResponses, GetBenefitNotificationSituationManagementUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/situation-management-url',
    ...options
});

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 이용 약관 화면
 */
export const getBenefitNotificationTermServiceUrl = <ThrowOnError extends boolean = false>(options: Options<GetBenefitNotificationTermServiceUrlData, ThrowOnError>): RequestResult<GetBenefitNotificationTermServiceUrlResponses, GetBenefitNotificationTermServiceUrlErrors, ThrowOnError> => (options.client ?? client).get<GetBenefitNotificationTermServiceUrlResponses, GetBenefitNotificationTermServiceUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-notification/term-service-url',
    ...options
});

/**
 * 완독 보상 현황 조회
 *
 * 로그인 회원이 오늘 완독 보상으로 받은 장수(dailyGrantedCount/dailyCap)와 이 콘텐츠의 오늘 수령 여부, 받기 가능 여부, 성인 여부, 행운권·응모권 잔액을 반환합니다. 콘텐츠 존재는 확인하지 않습니다(받기 시 확인).
 */
export const findBenefitReadReward = <ThrowOnError extends boolean = false>(options: Options<FindBenefitReadRewardData, ThrowOnError>): RequestResult<FindBenefitReadRewardResponses, FindBenefitReadRewardErrors, ThrowOnError> => (options.client ?? client).get<FindBenefitReadRewardResponses, FindBenefitReadRewardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-read-rewards',
    ...options
});

/**
 * 완독 보상 행운권 받기
 *
 * 완독 보상 행운권 1장(응모권 1장 동반)을 지급합니다. 만 19세 이상만 받을 수 있습니다(30403). 같은 콘텐츠는 하루 1회이며 다시 요청하면 지급 없이 현재 상태를 반환합니다(grantedLuckyCount=0). 1인 하루 3장을 넘기면 30400, 없는 콘텐츠는 30404입니다.
 */
export const saveBenefitReadReward = <ThrowOnError extends boolean = false>(options: Options<SaveBenefitReadRewardData, ThrowOnError>): RequestResult<SaveBenefitReadRewardResponses, SaveBenefitReadRewardErrors, ThrowOnError> => (options.client ?? client).post<SaveBenefitReadRewardResponses, SaveBenefitReadRewardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-read-rewards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 완독 보상 가능 콘텐츠 목록 조회
 *
 * 아티클·정책카드·동네소식·동네축제를 피드 목록과 같은 조건으로 조회해, 현재 보고 있는 콘텐츠와 오늘 완독 보상을 받은 콘텐츠를 빼고 종류별 앞 3개에서 랜덤으로 최대 6개를 반환합니다. 6개가 안 되면 각 종류의 다음 순번 후보에서 랜덤으로 채우고, 그래도 모자라면 적거나 비어 있을 수 있습니다. 하루 한도를 다 썼거나 미성년이어도 목록은 그대로 반환합니다.
 */
export const findBenefitReadRewardContentList = <ThrowOnError extends boolean = false>(options: Options<FindBenefitReadRewardContentListData, ThrowOnError>): RequestResult<FindBenefitReadRewardContentListResponses, FindBenefitReadRewardContentListErrors, ThrowOnError> => (options.client ?? client).get<FindBenefitReadRewardContentListResponses, FindBenefitReadRewardContentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-read-rewards/contents',
    ...options
});

/**
 * 행운권/응모권 잔액 조회
 *
 * 로그인 회원의 당일 유효 행운권 수량과 응모권 누적 수량을 반환합니다.
 */
export const findBenefitTicketBalance = <ThrowOnError extends boolean = false>(options?: Options<FindBenefitTicketBalanceData, ThrowOnError>): RequestResult<FindBenefitTicketBalanceResponses, FindBenefitTicketBalanceErrors, ThrowOnError> => (options?.client ?? client).get<FindBenefitTicketBalanceResponses, FindBenefitTicketBalanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-tickets',
    ...options
});

/**
 * 행운권 광고 더받기 수령 가능 상태 조회
 *
 * 광고 보고 행운권 더받기(오퍼월 RV) 수령 가능 여부와 다음 수령 가능 시각을 반환합니다. KST 00시부터 3시간 간격으로 1회 수령 가능하며, 받을 수 있으면 nextAvailableAt은 null입니다.
 */
export const findLuckyTicketAvailability = <ThrowOnError extends boolean = false>(options?: Options<FindLuckyTicketAvailabilityData, ThrowOnError>): RequestResult<FindLuckyTicketAvailabilityResponses, FindLuckyTicketAvailabilityErrors, ThrowOnError> => (options?.client ?? client).get<FindLuckyTicketAvailabilityResponses, FindLuckyTicketAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/benefit-tickets/lucky-ticket',
    ...options
});

/**
 * 휴대전화번호 인증 발송
 */
export const sendCertificationCellphone = <ThrowOnError extends boolean = false>(options: Options<SendCertificationCellphoneData, ThrowOnError>): RequestResult<SendCertificationCellphoneResponses, SendCertificationCellphoneErrors, ThrowOnError> => (options.client ?? client).post<SendCertificationCellphoneResponses, SendCertificationCellphoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/certification/cellphone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 인증 번호 확인
 */
export const certificationCheck = <ThrowOnError extends boolean = false>(options: Options<CertificationCheckData, ThrowOnError>): RequestResult<CertificationCheckResponses, CertificationCheckErrors, ThrowOnError> => (options.client ?? client).post<CertificationCheckResponses, CertificationCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/certification/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityWelloNewsData, ThrowOnError>): RequestResult<FeedbackCommunityWelloNewsResponses, FeedbackCommunityWelloNewsErrors, ThrowOnError> => (options.client ?? client).get<FeedbackCommunityWelloNewsResponses, FeedbackCommunityWelloNewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/community/wello-news/feedback/{communityIdIdx}',
    ...options
});

/**
 * 커뮤니티 - 웰로 뉴스 상세
 */
export const getCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsData, ThrowOnError>): RequestResult<GetCommunityWelloNewsResponses, GetCommunityWelloNewsErrors, ThrowOnError> => (options.client ?? client).get<GetCommunityWelloNewsResponses, GetCommunityWelloNewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/community/wello-news/{communityIdIdx}',
    ...options
});

/**
 * 커뮤니티 게시글 신고
 */
export const reportCommunity = <ThrowOnError extends boolean = false>(options: Options<ReportCommunityData, ThrowOnError>): RequestResult<ReportCommunityResponses, ReportCommunityErrors, ThrowOnError> => (options.client ?? client).post<ReportCommunityResponses, ReportCommunityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/community/{communityId}/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 로그인 멤버 정책 소식 좋아요&스크랩 정보 조회
 */
export const bestContentsFeedback = <ThrowOnError extends boolean = false>(options: Options<BestContentsFeedbackData, ThrowOnError>): RequestResult<BestContentsFeedbackResponses, BestContentsFeedbackErrors, ThrowOnError> => (options.client ?? client).get<BestContentsFeedbackResponses, BestContentsFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/contents/feedback/{bestContentsId}',
    ...options
});

/**
 * 문의내역 조회
 *
 * 문의 내역을 조회합니다
 */
export const inquiryList = <ThrowOnError extends boolean = false>(options: Options<InquiryListData, ThrowOnError>): RequestResult<InquiryListResponses, InquiryListErrors, ThrowOnError> => (options.client ?? client).get<InquiryListResponses, InquiryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/cs/inquiry',
    ...options
});

/**
 * 문의하기
 *
 * 문의내용을 등록합니다
 */
export const saveInquiry1 = <ThrowOnError extends boolean = false>(options: Options<SaveInquiry1Data, ThrowOnError>): RequestResult<SaveInquiry1Responses, SaveInquiry1Errors, ThrowOnError> => (options.client ?? client).post<SaveInquiry1Responses, SaveInquiry1Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/cs/inquiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 문의상세 조회
 *
 * 문의 상세 내역을 조회합니다
 */
export const getInquiry = <ThrowOnError extends boolean = false>(options: Options<GetInquiryData, ThrowOnError>): RequestResult<GetInquiryResponses, GetInquiryErrors, ThrowOnError> => (options.client ?? client).get<GetInquiryResponses, GetInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/cs/inquiry/{inquiryId}',
    ...options
});

/**
 * 병원 상세 조회
 */
export const getEmergencyRoomList = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListData, ThrowOnError>): RequestResult<GetEmergencyRoomListResponses, GetEmergencyRoomListErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomListResponses, GetEmergencyRoomListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/emergency-room',
    ...options
});

/**
 * 병원 상세 조회
 */
export const getEmergencyRoom = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomData, ThrowOnError>): RequestResult<GetEmergencyRoomResponses, GetEmergencyRoomErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomResponses, GetEmergencyRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/emergency-room/{emergencyRoomId}',
    ...options
});

/**
 * SSP 시청 이력 저장
 *
 * 전면/리워드 비디오·로또 시청 이력을 저장하고 혜택을 처리합니다. lottoYN=true면 행운의 로또 응모(lottery), false면 sspType별 처리(INTERSTITIAL_VIDEO=긁기 scratch, REWARDED_VIDEO=행운권 지급). 응답은 {scratch, lottery} 통합 형태로 해당 분기 payload만 채워진다.
 */
export const saveAdpopcornSspHistory = <ThrowOnError extends boolean = false>(options: Options<SaveAdpopcornSspHistoryData, ThrowOnError>): RequestResult<SaveAdpopcornSspHistoryResponses, SaveAdpopcornSspHistoryErrors, ThrowOnError> => (options.client ?? client).post<SaveAdpopcornSspHistoryResponses, SaveAdpopcornSspHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/external/adpopcorn-ssp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 피드 목록 조회 (회원)
 *
 * 회원 맞춤 필터가 적용된 피드 목록을 조회합니다
 */
export const getFeedList = <ThrowOnError extends boolean = false>(options: Options<GetFeedListData, ThrowOnError>): RequestResult<GetFeedListResponses, GetFeedListErrors, ThrowOnError> => (options.client ?? client).post<GetFeedListResponses, GetFeedListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/feed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 이벤트 신청
 */
export const applyHomeDonationEvent = <ThrowOnError extends boolean = false>(options: Options<ApplyHomeDonationEventData, ThrowOnError>): RequestResult<ApplyHomeDonationEventResponses, ApplyHomeDonationEventErrors, ThrowOnError> => (options.client ?? client).post<ApplyHomeDonationEventResponses, ApplyHomeDonationEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event',
    ...options
});

/**
 * 포인트 지급 목록
 */
export const getEventHistoryList = <ThrowOnError extends boolean = false>(options?: Options<GetEventHistoryListData, ThrowOnError>): RequestResult<GetEventHistoryListResponses, GetEventHistoryListErrors, ThrowOnError> => (options?.client ?? client).get<GetEventHistoryListResponses, GetEventHistoryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event-history',
    ...options
});

/**
 * 초대 이벤트 참여 여부
 */
export const getInviteeEventReceived = <ThrowOnError extends boolean = false>(options: Options<GetInviteeEventReceivedData, ThrowOnError>): RequestResult<GetInviteeEventReceivedResponses, GetInviteeEventReceivedErrors, ThrowOnError> => (options.client ?? client).get<GetInviteeEventReceivedResponses, GetInviteeEventReceivedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event-history/invitee-event/received',
    ...options
});

/**
 * 이벤트 요약(총 적립금, 가입한 친구, 친구 기부 횟수)
 */
export const getMyInviteEventHistorySummary = <ThrowOnError extends boolean = false>(options?: Options<GetMyInviteEventHistorySummaryData, ThrowOnError>): RequestResult<GetMyInviteEventHistorySummaryResponses, GetMyInviteEventHistorySummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetMyInviteEventHistorySummaryResponses, GetMyInviteEventHistorySummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event-history/summary',
    ...options
});

/**
 * 이벤트 진행 여부
 */
export const isEventInProgress = <ThrowOnError extends boolean = false>(options: Options<IsEventInProgressData, ThrowOnError>): RequestResult<IsEventInProgressResponses, IsEventInProgressErrors, ThrowOnError> => (options.client ?? client).get<IsEventInProgressResponses, IsEventInProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event/is-progressing',
    ...options
});

/**
 * 답례품 기준 참여 가능 이벤트 리워드 목록
 *
 * 해당 답례품으로 참여할 수 있는 기부·후기 이벤트의 지급 리워드를 조회합니다. 카카오뱅크는 상품권 금액(naverPay), 그 밖의 채널은 웰포인트(point)가 채워집니다. 로그인 회원이 이미 참여한 중복 참여 불가 기부 이벤트는 제외됩니다. 논산 룰렛 이벤트는 논산 답례품이고 진행 중(기간 내·경품 미소진)이면 채널과 무관하게 naverPay 30000 으로 포함되며(합계 포함), 로그인 회원이 이미 참여했으면 제외됩니다. 순서는 후기 이벤트가 맨 앞이고, 그 뒤로 기부 이벤트와 논산 룰렛이 리워드액 내림차순입니다(금액을 모르는 이벤트는 각 묶음의 맨 뒤).
 */
export const findEventRewardList = <ThrowOnError extends boolean = false>(options: Options<FindEventRewardListData, ThrowOnError>): RequestResult<FindEventRewardListResponses, FindEventRewardListErrors, ThrowOnError> => (options.client ?? client).get<FindEventRewardListResponses, FindEventRewardListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation-event/reward',
    ...options
});

/**
 * 제주패스 기부증서 조회
 */
export const getHomeInstitutionCertificate = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionCertificateData, ThrowOnError>): RequestResult<GetHomeInstitutionCertificateResponses, GetHomeInstitutionCertificateErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeInstitutionCertificateResponses, GetHomeInstitutionCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation/certificate',
    ...options
});

/**
 * 최근 투주패스 기부증서 아이디 조회
 */
export const getLatestHomeInstitutionCertificate = <ThrowOnError extends boolean = false>(options?: Options<GetLatestHomeInstitutionCertificateData, ThrowOnError>): RequestResult<GetLatestHomeInstitutionCertificateResponses, GetLatestHomeInstitutionCertificateErrors, ThrowOnError> => (options?.client ?? client).get<GetLatestHomeInstitutionCertificateResponses, GetLatestHomeInstitutionCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation/certificate/latest',
    ...options
});

/**
 * 기부내역 상세 조회
 */
export const getHomeDonationHistory = <ThrowOnError extends boolean = false>(options: Options<GetHomeDonationHistoryData, ThrowOnError>): RequestResult<GetHomeDonationHistoryResponses, GetHomeDonationHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetHomeDonationHistoryResponses, GetHomeDonationHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation/epay-no/{epayNo}',
    ...options
});

/**
 * 기부내역 조회
 */
export const getHomeDonationHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetHomeDonationHistoryListData, ThrowOnError>): RequestResult<GetHomeDonationHistoryListResponses, GetHomeDonationHistoryListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeDonationHistoryListResponses, GetHomeDonationHistoryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation/history',
    ...options
});

/**
 * 나의 기부 관련 내역 조회
 */
export const getMyDonationInfo = <ThrowOnError extends boolean = false>(options?: Options<GetMyDonationInfoData, ThrowOnError>): RequestResult<GetMyDonationInfoResponses, GetMyDonationInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetMyDonationInfoResponses, GetMyDonationInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-donation/my',
    ...options
});

/**
 * 1:1 문의 목록 조회
 *
 * 노출 중인 문의를 최신순으로 조회한다. 남이 쓴 비밀글은 내용·답변·첨부·지자체·상품명·옵션을 비운다. page 1 이상, size 5~200 을 벗어나면 30001.
 */
export const findHomeInquiryList = <ThrowOnError extends boolean = false>(options: Options<FindHomeInquiryListData, ThrowOnError>): RequestResult<FindHomeInquiryListResponses, FindHomeInquiryListErrors, ThrowOnError> => (options.client ?? client).get<FindHomeInquiryListResponses, FindHomeInquiryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry',
    ...options
});

/**
 * 1:1 문의 등록
 *
 * 답례품 문의는 productNumber, 주문·배송 문의는 giftOrderProductId 가 필수이고 주문·배송 문의가 아니면 giftOrderProductId 를 보낼 수 없다(30001). 본인 주문 상품이 아니면 30401. 인입(접속) 채널은 토큰의 entry 로 저장한다(없거나 모르는 값이면 웰로).
 */
export const saveHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<SaveHomeInquiryData, ThrowOnError>): RequestResult<SaveHomeInquiryResponses, SaveHomeInquiryErrors, ThrowOnError> => (options.client ?? client).post<SaveHomeInquiryResponses, SaveHomeInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 1:1 문의 내 목록 조회
 *
 * 본인의 노출 중인 문의 전체를 최신순으로 조회한다(페이지 없음).
 */
export const findMyHomeInquiryList = <ThrowOnError extends boolean = false>(options?: Options<FindMyHomeInquiryListData, ThrowOnError>): RequestResult<FindMyHomeInquiryListResponses, FindMyHomeInquiryListErrors, ThrowOnError> => (options?.client ?? client).get<FindMyHomeInquiryListResponses, FindMyHomeInquiryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry/my',
    ...options
});

/**
 * 1:1 문의 삭제
 *
 * 본인의 노출 중인 문의를 숨긴다. 없거나 남의 문의거나 이미 숨김이면 30404.
 */
export const deleteHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<DeleteHomeInquiryData, ThrowOnError>): RequestResult<DeleteHomeInquiryResponses, DeleteHomeInquiryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteHomeInquiryResponses, DeleteHomeInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry/{homeInquiryId}',
    ...options
});

/**
 * 1:1 문의 상세 조회
 *
 * 본인의 노출 중인 문의만 조회한다. 없거나 남의 문의거나 숨김이면 30404.
 */
export const findHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<FindHomeInquiryData, ThrowOnError>): RequestResult<FindHomeInquiryResponses, FindHomeInquiryErrors, ThrowOnError> => (options.client ?? client).get<FindHomeInquiryResponses, FindHomeInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry/{homeInquiryId}',
    ...options
});

/**
 * 1:1 문의 수정
 *
 * 본인의 노출 중인 문의만 수정한다. 없거나 남의 문의거나 숨김이면 30404.
 */
export const updateHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<UpdateHomeInquiryData, ThrowOnError>): RequestResult<UpdateHomeInquiryResponses, UpdateHomeInquiryErrors, ThrowOnError> => (options.client ?? client).put<UpdateHomeInquiryResponses, UpdateHomeInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-inquiry/{homeInquiryId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 이전 기부 이력 수납 완료 처리
 */
export const beforeCompleteDonation = <ThrowOnError extends boolean = false>(options?: Options<BeforeCompleteDonationData, ThrowOnError>): RequestResult<BeforeCompleteDonationResponses, BeforeCompleteDonationErrors, ThrowOnError> => (options?.client ?? client).post<BeforeCompleteDonationResponses, BeforeCompleteDonationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/donation/before-complete',
    ...options
});

/**
 * 기부가능 여부 조회
 */
export const checkDonationAvailable = <ThrowOnError extends boolean = false>(options: Options<CheckDonationAvailableData, ThrowOnError>): RequestResult<CheckDonationAvailableResponses, CheckDonationAvailableErrors, ThrowOnError> => (options.client ?? client).post<CheckDonationAvailableResponses, CheckDonationAvailableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/donation/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 기부 수납 완료 처리
 */
export const completeDonation = <ThrowOnError extends boolean = false>(options: Options<CompleteDonationData, ThrowOnError>): RequestResult<CompleteDonationResponses, CompleteDonationErrors, ThrowOnError> => (options.client ?? client).post<CompleteDonationResponses, CompleteDonationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/donation/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 최근 기부 정보 조회
 */
export const latestCompleteDonation = <ThrowOnError extends boolean = false>(options?: Options<LatestCompleteDonationData, ThrowOnError>): RequestResult<LatestCompleteDonationResponses, LatestCompleteDonationErrors, ThrowOnError> => (options?.client ?? client).get<LatestCompleteDonationResponses, LatestCompleteDonationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/donation/latest-complete',
    ...options
});

/**
 * 기부 프로세스 처리 (기부만/답례품 단건 주문)
 */
export const processDonation = <ThrowOnError extends boolean = false>(options: Options<ProcessDonationData, ThrowOnError>): RequestResult<ProcessDonationResponses, ProcessDonationErrors, ThrowOnError> => (options.client ?? client).post<ProcessDonationResponses, ProcessDonationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/donation/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 회원가입
 */
export const createMember = <ThrowOnError extends boolean = false>(options?: Options<CreateMemberData, ThrowOnError>): RequestResult<CreateMemberResponses, CreateMemberErrors, ThrowOnError> => (options?.client ?? client).post<CreateMemberResponses, CreateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/member',
    ...options
});

/**
 * 회원여부 조회
 */
export const checkMember = <ThrowOnError extends boolean = false>(options?: Options<CheckMemberData, ThrowOnError>): RequestResult<CheckMemberResponses, CheckMemberErrors, ThrowOnError> => (options?.client ?? client).get<CheckMemberResponses, CheckMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-love/member/check',
    ...options
});

/**
 * 목록 조회
 */
export const getHomeNoticeList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeNoticeListData, ThrowOnError>): RequestResult<GetHomeNoticeListResponses, GetHomeNoticeListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeNoticeListResponses, GetHomeNoticeListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home-notice',
    ...options
});

/**
 * 배송지 목록 조회
 */
export const getDeliveryAddressList = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryAddressListData, ThrowOnError>): RequestResult<GetDeliveryAddressListResponses, GetDeliveryAddressListErrors, ThrowOnError> => (options.client ?? client).get<GetDeliveryAddressListResponses, GetDeliveryAddressListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery',
    ...options
});

/**
 * 배송지 등록
 */
export const createDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<CreateDeliveryAddressData, ThrowOnError>): RequestResult<CreateDeliveryAddressResponses, CreateDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).post<CreateDeliveryAddressResponses, CreateDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 기본 배송지 상세 조회
 */
export const getPrimaryDeliveryAddress = <ThrowOnError extends boolean = false>(options?: Options<GetPrimaryDeliveryAddressData, ThrowOnError>): RequestResult<GetPrimaryDeliveryAddressResponses, GetPrimaryDeliveryAddressErrors, ThrowOnError> => (options?.client ?? client).get<GetPrimaryDeliveryAddressResponses, GetPrimaryDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery/primary',
    ...options
});

/**
 * 배송지 삭제
 */
export const deleteDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<DeleteDeliveryAddressData, ThrowOnError>): RequestResult<DeleteDeliveryAddressResponses, DeleteDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDeliveryAddressResponses, DeleteDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery/{addressId}',
    ...options
});

/**
 * 배송지 상세 조회
 */
export const getDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryAddressData, ThrowOnError>): RequestResult<GetDeliveryAddressResponses, GetDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).get<GetDeliveryAddressResponses, GetDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery/{addressId}',
    ...options
});

/**
 * 배송지 수정
 */
export const updateDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateDeliveryAddressData, ThrowOnError>): RequestResult<UpdateDeliveryAddressResponses, UpdateDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).put<UpdateDeliveryAddressResponses, UpdateDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/delivery/{addressId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지정사업 응원하기 삭제
 */
export const deleteDonationBusinessComment = <ThrowOnError extends boolean = false>(options: Options<DeleteDonationBusinessCommentData, ThrowOnError>): RequestResult<DeleteDonationBusinessCommentResponses, DeleteDonationBusinessCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDonationBusinessCommentResponses, DeleteDonationBusinessCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/donation-business-comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentList = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessCommentListData, ThrowOnError>): RequestResult<GetDonationBusinessCommentListResponses, GetDonationBusinessCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetDonationBusinessCommentListResponses, GetDonationBusinessCommentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/donation-business-comment',
    ...options
});

/**
 * 지정사업 응원하기
 */
export const saveDonationBusinessComment = <ThrowOnError extends boolean = false>(options: Options<SaveDonationBusinessCommentData, ThrowOnError>): RequestResult<SaveDonationBusinessCommentResponses, SaveDonationBusinessCommentErrors, ThrowOnError> => (options.client ?? client).post<SaveDonationBusinessCommentResponses, SaveDonationBusinessCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/donation-business-comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지정사업 응원하기 수정
 */
export const updateDonationBusinessComment = <ThrowOnError extends boolean = false>(options: Options<UpdateDonationBusinessCommentData, ThrowOnError>): RequestResult<UpdateDonationBusinessCommentResponses, UpdateDonationBusinessCommentErrors, ThrowOnError> => (options.client ?? client).put<UpdateDonationBusinessCommentResponses, UpdateDonationBusinessCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/donation-business-comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 기부예약
 */
export const createDonationReservation = <ThrowOnError extends boolean = false>(options: Options<CreateDonationReservationData, ThrowOnError>): RequestResult<CreateDonationReservationResponses, CreateDonationReservationErrors, ThrowOnError> => (options.client ?? client).post<CreateDonationReservationResponses, CreateDonationReservationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/donation/reservation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지급받은 랜덤티켓 수 및 참여 가능한지 여부 조회
 */
export const getDecemberRandomTicketCount = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberRandomTicketCountData, ThrowOnError>): RequestResult<GetDecemberRandomTicketCountResponses, GetDecemberRandomTicketCountErrors, ThrowOnError> => (options?.client ?? client).get<GetDecemberRandomTicketCountResponses, GetDecemberRandomTicketCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/event/december/random-ticket-count',
    ...options
});

/**
 * 랜덤티켓 오픈
 */
export const openRandomTicket = <ThrowOnError extends boolean = false>(options: Options<OpenRandomTicketData, ThrowOnError>): RequestResult<OpenRandomTicketResponses, OpenRandomTicketErrors, ThrowOnError> => (options.client ?? client).put<OpenRandomTicketResponses, OpenRandomTicketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/event/december/random-ticket/{randomTicketId}',
    ...options
});

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewList = <ThrowOnError extends boolean = false>(options?: Options<GetGiftOrderProductReviewListData, ThrowOnError>): RequestResult<GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewListErrors, ThrowOnError> => (options?.client ?? client).get<GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review',
    ...options
});

/**
 * 리뷰 등록
 */
export const saveGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<SaveGiftOrderProductReviewData, ThrowOnError>): RequestResult<SaveGiftOrderProductReviewResponses, SaveGiftOrderProductReviewErrors, ThrowOnError> => (options.client ?? client).post<SaveGiftOrderProductReviewResponses, SaveGiftOrderProductReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 리뷰 수정
 */
export const updateGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<UpdateGiftOrderProductReviewData, ThrowOnError>): RequestResult<UpdateGiftOrderProductReviewResponses, UpdateGiftOrderProductReviewErrors, ThrowOnError> => (options.client ?? client).put<UpdateGiftOrderProductReviewResponses, UpdateGiftOrderProductReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 나의 리뷰 목록 조회
 */
export const getMyGiftOrderProductReviewList = <ThrowOnError extends boolean = false>(options?: Options<GetMyGiftOrderProductReviewListData, ThrowOnError>): RequestResult<GetMyGiftOrderProductReviewListResponses, GetMyGiftOrderProductReviewListErrors, ThrowOnError> => (options?.client ?? client).get<GetMyGiftOrderProductReviewListResponses, GetMyGiftOrderProductReviewListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review/my',
    ...options
});

/**
 * 리뷰 삭제
 */
export const removeGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<RemoveGiftOrderProductReviewData, ThrowOnError>): RequestResult<RemoveGiftOrderProductReviewResponses, RemoveGiftOrderProductReviewErrors, ThrowOnError> => (options.client ?? client).delete<RemoveGiftOrderProductReviewResponses, RemoveGiftOrderProductReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review/{reviewId}',
    ...options
});

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<GetGiftOrderProductReviewData, ThrowOnError>): RequestResult<GetGiftOrderProductReviewResponses, GetGiftOrderProductReviewErrors, ThrowOnError> => (options.client ?? client).get<GetGiftOrderProductReviewResponses, GetGiftOrderProductReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift-review/{reviewId}',
    ...options
});

/**
 * 답례품 주문 목록
 */
export const getGiftOrderHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetGiftOrderHistoryListData, ThrowOnError>): RequestResult<GetGiftOrderHistoryListResponses, GetGiftOrderHistoryListErrors, ThrowOnError> => (options.client ?? client).get<GetGiftOrderHistoryListResponses, GetGiftOrderHistoryListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift/order',
    ...options
});

/**
 * 답례품 주문 상세
 */
export const getGiftOrderHistory = <ThrowOnError extends boolean = false>(options: Options<GetGiftOrderHistoryData, ThrowOnError>): RequestResult<GetGiftOrderHistoryResponses, GetGiftOrderHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetGiftOrderHistoryResponses, GetGiftOrderHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift/order/{orderId}',
    ...options
});

/**
 * 답례품 주문 배송지 변경
 */
export const updateGiftOrderAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateGiftOrderAddressData, ThrowOnError>): RequestResult<UpdateGiftOrderAddressResponses, UpdateGiftOrderAddressErrors, ThrowOnError> => (options.client ?? client).put<UpdateGiftOrderAddressResponses, UpdateGiftOrderAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift/order/{orderId}/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 답례품 주문 배송조회
 */
export const getDeliveryTracking2 = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryTracking2Data, ThrowOnError>): RequestResult<GetDeliveryTracking2Responses, GetDeliveryTracking2Errors, ThrowOnError> => (options.client ?? client).get<GetDeliveryTracking2Responses, GetDeliveryTracking2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift/order/{orderId}/delivery',
    ...options
});

/**
 * 답례품 주문 취소/교환/환불 신청
 */
export const updateGiftOrderStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateGiftOrderStatusData, ThrowOnError>): RequestResult<UpdateGiftOrderStatusResponses, UpdateGiftOrderStatusErrors, ThrowOnError> => (options.client ?? client).put<UpdateGiftOrderStatusResponses, UpdateGiftOrderStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/gift/order/{orderId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionEventListData, ThrowOnError>): RequestResult<GetHomeInstitutionEventListResponses, GetHomeInstitutionEventListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeInstitutionEventListResponses, GetHomeInstitutionEventListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/institution-event',
    ...options
});

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetOrderedHomeInstitutionEventListData, ThrowOnError>): RequestResult<GetOrderedHomeInstitutionEventListResponses, GetOrderedHomeInstitutionEventListErrors, ThrowOnError> => (options?.client ?? client).get<GetOrderedHomeInstitutionEventListResponses, GetOrderedHomeInstitutionEventListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/institution-event/ordered',
    ...options
});

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionPolicyListData, ThrowOnError>): RequestResult<GetHomeInstitutionPolicyListResponses, GetHomeInstitutionPolicyListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionPolicyListResponses, GetHomeInstitutionPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/home/institution/policy',
    ...options
});

/**
 * 로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedback = <ThrowOnError extends boolean = false>(options: Options<HometownNewsFeedbackData, ThrowOnError>): RequestResult<HometownNewsFeedbackResponses, HometownNewsFeedbackErrors, ThrowOnError> => (options.client ?? client).get<HometownNewsFeedbackResponses, HometownNewsFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/hometown-news/feedback/{hometownNewsId}',
    ...options
});

/**
 * 동네 소식 콘텐츠 상세
 */
export const hometownNews = <ThrowOnError extends boolean = false>(options: Options<HometownNewsData, ThrowOnError>): RequestResult<HometownNewsResponses, HometownNewsErrors, ThrowOnError> => (options.client ?? client).get<HometownNewsResponses, HometownNewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/hometown-news/{hometownNewsIdIdx}',
    ...options
});

/**
 * 서비스 해지(회원 탈퇴)
 *
 * 카카오뱅크 웹뷰의 MY > 설정 > 서비스 해지에서 호출합니다. 요청 본문은 없습니다.
 * 탈퇴 사유는 서버가 "카카오뱅크 서비스 해지"로 남깁니다.
 * 해지 후 같은 카카오뱅크 계정으로 재가입할 수 있습니다.
 * 오류: 30400(카카오뱅크 가입 회원이 아님)
 */
export const resignMember1 = <ThrowOnError extends boolean = false>(options?: Options<ResignMember1Data, ThrowOnError>): RequestResult<ResignMember1Responses, ResignMember1Errors, ThrowOnError> => (options?.client ?? client).delete<ResignMember1Responses, ResignMember1Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/kakao-bank/member',
    ...options
});

/**
 * 포스트백 신호(Pinkey) 전달
 */
export const sendPinkey = <ThrowOnError extends boolean = false>(options?: Options<SendPinkeyData, ThrowOnError>): RequestResult<SendPinkeyResponses, SendPinkeyErrors, ThrowOnError> => (options?.client ?? client).post<SendPinkeyResponses, SendPinkeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/kb',
    ...options
});

/**
 * 1. 가구원 정보제공 동의 링크 조회
 */
export const confirmHouseholdInfoAgreement = <ThrowOnError extends boolean = false>(options: Options<ConfirmHouseholdInfoAgreementData, ThrowOnError>): RequestResult<ConfirmHouseholdInfoAgreementResponses, ConfirmHouseholdInfoAgreementErrors, ThrowOnError> => (options.client ?? client).get<ConfirmHouseholdInfoAgreementResponses, ConfirmHouseholdInfoAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/kosaf/confirm-household-info-agreement',
    ...options
});

/**
 * 본인 주문 목록 조회
 *
 * 본인의 주문 목록을 페이징 조회합니다.
 */
export const findAllOrders = <ThrowOnError extends boolean = false>(options?: Options<FindAllOrdersData, ThrowOnError>): RequestResult<FindAllOrdersResponses, FindAllOrdersErrors, ThrowOnError> => (options?.client ?? client).get<FindAllOrdersResponses, FindAllOrdersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders',
    ...options
});

/**
 * 본인 주문 상세 조회 (주문번호)
 *
 * 주문번호(orderNo)로 본인의 주문 상세 정보를 조회합니다.
 */
export const findOrderByNumber = <ThrowOnError extends boolean = false>(options: Options<FindOrderByNumberData, ThrowOnError>): RequestResult<FindOrderByNumberResponses, FindOrderByNumberErrors, ThrowOnError> => (options.client ?? client).get<FindOrderByNumberResponses, FindOrderByNumberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/by-number/{orderNo}',
    ...options
});

/**
 * 통합 주문 목록 조회 (기부몰 + 포인트몰 + 로컬마켓)
 *
 * 기간 파라미터(startDate, endDate)는 각각 null 허용. 둘 다 null 이면 전체 기간 조회. startDate>endDate 이면 returnCode 30400 응답.
 */
export const findUnifiedOrders = <ThrowOnError extends boolean = false>(options?: Options<FindUnifiedOrdersData, ThrowOnError>): RequestResult<FindUnifiedOrdersResponses, FindUnifiedOrdersErrors, ThrowOnError> => (options?.client ?? client).get<FindUnifiedOrdersResponses, FindUnifiedOrdersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/unified',
    ...options
});

/**
 * 본인 주문 상세 조회
 *
 * 본인의 주문 단건 상세 정보를 조회합니다.
 */
export const findOrder = <ThrowOnError extends boolean = false>(options: Options<FindOrderData, ThrowOnError>): RequestResult<FindOrderResponses, FindOrderErrors, ThrowOnError> => (options.client ?? client).get<FindOrderResponses, FindOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}',
    ...options
});

/**
 * 주문 취소
 *
 * 본인의 주문을 취소합니다.
 */
export const cancelOrder = <ThrowOnError extends boolean = false>(options: Options<CancelOrderData, ThrowOnError>): RequestResult<CancelOrderResponses, CancelOrderErrors, ThrowOnError> => (options.client ?? client).put<CancelOrderResponses, CancelOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 구매 확정
 *
 * 본인의 주문을 구매 확정 처리합니다.
 */
export const confirmPurchase = <ThrowOnError extends boolean = false>(options: Options<ConfirmPurchaseData, ThrowOnError>): RequestResult<ConfirmPurchaseResponses, ConfirmPurchaseErrors, ThrowOnError> => (options.client ?? client).put<ConfirmPurchaseResponses, ConfirmPurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/confirm',
    ...options
});

/**
 * 배송 조회
 *
 * 배송 조회.
 *
 * <p>굿스플로우 배송 추적 API를 통해 실시간 배송 상태 및 이력을 조회한다.
 * 주문 상세의 <code>deliveryId</code>를 사용하여 호출한다.</p>
 */
export const getDeliveryTracking1 = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryTracking1Data, ThrowOnError>): RequestResult<GetDeliveryTracking1Responses, GetDeliveryTracking1Errors, ThrowOnError> => (options.client ?? client).get<GetDeliveryTracking1Responses, GetDeliveryTracking1Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking',
    ...options
});

/**
 * 주문 배송지 일괄 변경
 *
 * 주문 배송지 일괄 변경.
 *
 * <p>주문 내 모든 입점업체의 배송지를 동일하게 변경한다.
 * 모든 상품이 주문 완료(PRODUCT_ORDERED) 상태일 때만 변경 가능하다.</p>
 */
export const updateAllDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateAllDeliveryAddressData, ThrowOnError>): RequestResult<UpdateAllDeliveryAddressResponses, UpdateAllDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).put<UpdateAllDeliveryAddressResponses, UpdateAllDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/delivery-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 개별/선택 취소 (선택한 orderProduct 일괄)
 */
export const cancelOrderProducts = <ThrowOnError extends boolean = false>(options: Options<CancelOrderProductsData, ThrowOnError>): RequestResult<CancelOrderProductsResponses, CancelOrderProductsErrors, ThrowOnError> => (options.client ?? client).put<CancelOrderProductsResponses, CancelOrderProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/order-products/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 개별/선택 교환 (선택한 orderProduct 일괄)
 */
export const exchangeOrderProducts = <ThrowOnError extends boolean = false>(options: Options<ExchangeOrderProductsData, ThrowOnError>): RequestResult<ExchangeOrderProductsResponses, ExchangeOrderProductsErrors, ThrowOnError> => (options.client ?? client).post<ExchangeOrderProductsResponses, ExchangeOrderProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/order-products/exchange',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 개별/선택 반품 (선택한 orderProduct 일괄)
 */
export const returnOrderProducts = <ThrowOnError extends boolean = false>(options: Options<ReturnOrderProductsData, ThrowOnError>): RequestResult<ReturnOrderProductsResponses, ReturnOrderProductsErrors, ThrowOnError> => (options.client ?? client).post<ReturnOrderProductsResponses, ReturnOrderProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/order-products/return',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 반품 요청
 *
 * 반품 요청.
 */
export const requestReturn = <ThrowOnError extends boolean = false>(options: Options<RequestReturnData, ThrowOnError>): RequestResult<RequestReturnResponses, RequestReturnErrors, ThrowOnError> => (options.client ?? client).post<RequestReturnResponses, RequestReturnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{orderProductId}/return',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 상품별 취소
 *
 * 본인의 주문 내 특정 상품을 취소합니다.
 */
export const cancelOrderProduct = <ThrowOnError extends boolean = false>(options: Options<CancelOrderProductData, ThrowOnError>): RequestResult<CancelOrderProductResponses, CancelOrderProductErrors, ThrowOnError> => (options.client ?? client).put<CancelOrderProductResponses, CancelOrderProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 상품 전체 취소 (같은 상품의 모든 옵션)
 */
export const cancelProduct = <ThrowOnError extends boolean = false>(options: Options<CancelProductData, ThrowOnError>): RequestResult<CancelProductResponses, CancelProductErrors, ThrowOnError> => (options.client ?? client).put<CancelProductResponses, CancelProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 상품별 구매 확정
 *
 * 본인의 주문 내 특정 상품을 구매 확정 처리합니다.
 */
export const confirmOrderProduct = <ThrowOnError extends boolean = false>(options: Options<ConfirmOrderProductData, ThrowOnError>): RequestResult<ConfirmOrderProductResponses, ConfirmOrderProductErrors, ThrowOnError> => (options.client ?? client).put<ConfirmOrderProductResponses, ConfirmOrderProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/confirm',
    ...options
});

/**
 * 상품 전체 교환 (같은 상품의 모든 옵션)
 */
export const exchangeProduct = <ThrowOnError extends boolean = false>(options: Options<ExchangeProductData, ThrowOnError>): RequestResult<ExchangeProductResponses, ExchangeProductErrors, ThrowOnError> => (options.client ?? client).post<ExchangeProductResponses, ExchangeProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/exchange-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 취소/반품/교환용 주문 상품 조회
 *
 * 취소/반품/교환 화면에 필요한 주문 상품(옵션) 목록을 조회한다.
 */
export const getOrderItemsForAction = <ThrowOnError extends boolean = false>(options: Options<GetOrderItemsForActionData, ThrowOnError>): RequestResult<GetOrderItemsForActionResponses, GetOrderItemsForActionErrors, ThrowOnError> => (options.client ?? client).get<GetOrderItemsForActionResponses, GetOrderItemsForActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/order-items',
    ...options
});

/**
 * 상품 기준 환불 예상 금액 조회
 *
 * 상품 기준 환불 예상 금액 조회.
 *
 * <p>반품 요청 전, 해당 상품을 반품했을 때 예상되는 환불 금액을 미리 계산하여 반환한다.</p>
 */
export const getRefundEstimate = <ThrowOnError extends boolean = false>(options: Options<GetRefundEstimateData, ThrowOnError>): RequestResult<GetRefundEstimateResponses, GetRefundEstimateErrors, ThrowOnError> => (options.client ?? client).get<GetRefundEstimateResponses, GetRefundEstimateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-estimate',
    ...options
});

/**
 * 상품 기준 환불 정보 조회 (교환 제외)
 *
 * 주문-상품 기준 환불 정보를 조회한다 (교환 제외).
 *
 * <p>특정 상품 그룹의 결제/포인트/쿠폰 환불 현황과 반품 이력을 반환한다.</p>
 */
export const getProductRefundInfo = <ThrowOnError extends boolean = false>(options: Options<GetProductRefundInfoData, ThrowOnError>): RequestResult<GetProductRefundInfoResponses, GetProductRefundInfoErrors, ThrowOnError> => (options.client ?? client).get<GetProductRefundInfoResponses, GetProductRefundInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-info',
    ...options
});

/**
 * 상품 전체 반품 (같은 상품의 모든 옵션)
 */
export const returnProduct = <ThrowOnError extends boolean = false>(options: Options<ReturnProductData, ThrowOnError>): RequestResult<ReturnProductResponses, ReturnProductErrors, ThrowOnError> => (options.client ?? client).post<ReturnProductResponses, ReturnProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/return-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 결제 영수증 조회
 *
 * 본인의 주문에 대한 결제 영수증을 조회합니다.
 */
export const getReceipt = <ThrowOnError extends boolean = false>(options: Options<GetReceiptData, ThrowOnError>): RequestResult<GetReceiptResponses, GetReceiptErrors, ThrowOnError> => (options.client ?? client).get<GetReceiptResponses, GetReceiptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/receipt',
    ...options
});

/**
 * 환불 정보 조회 (교환 제외)
 *
 * 주문의 환불 정보를 조회한다 (교환 제외).
 *
 * <p>결제 정보, 포인트/쿠폰 환불 현황, 반품 이력을 반환한다.</p>
 */
export const getRefundInfo = <ThrowOnError extends boolean = false>(options: Options<GetRefundInfoData, ThrowOnError>): RequestResult<GetRefundInfoResponses, GetRefundInfoErrors, ThrowOnError> => (options.client ?? client).get<GetRefundInfoResponses, GetRefundInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/refund-info',
    ...options
});

/**
 * 반품 요청 취소
 *
 * 반품 요청 취소 (관리자 승인 전만 가능).
 */
export const cancelReturn = <ThrowOnError extends boolean = false>(options: Options<CancelReturnData, ThrowOnError>): RequestResult<CancelReturnResponses, CancelReturnErrors, ThrowOnError> => (options.client ?? client).put<CancelReturnResponses, CancelReturnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/return/{returnId}/cancel',
    ...options
});

/**
 * 거래명세서 조회
 *
 * 본인의 주문에 대한 거래명세서를 조회합니다.
 */
export const getTransactionStatement = <ThrowOnError extends boolean = false>(options: Options<GetTransactionStatementData, ThrowOnError>): RequestResult<GetTransactionStatementResponses, GetTransactionStatementErrors, ThrowOnError> => (options.client ?? client).get<GetTransactionStatementResponses, GetTransactionStatementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/transaction-statement',
    ...options
});

/**
 * 입점업체별 배송지 변경
 *
 * 입점업체별 배송지 변경.
 *
 * <p>특정 입점업체의 배송지만 변경한다.
 * 해당 입점업체의 모든 상품이 주문 완료(PRODUCT_ORDERED) 상태일 때만 변경 가능하다.</p>
 */
export const updateVendorDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateVendorDeliveryAddressData, ThrowOnError>): RequestResult<UpdateVendorDeliveryAddressResponses, UpdateVendorDeliveryAddressErrors, ThrowOnError> => (options.client ?? client).put<UpdateVendorDeliveryAddressResponses, UpdateVendorDeliveryAddressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market-orders/{orderId}/vendors/{vendorId}/delivery-address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 사전주문 생성 (장바구니 → 주문서)
 *
 * 사전주문 생성.
 *
 * <p>장바구니에서 선택한 아이템으로 사전주문을 생성하고, 주문서 화면에 필요한 데이터를 반환한다.</p>
 */
export const createBeforeOrder = <ThrowOnError extends boolean = false>(options: Options<CreateBeforeOrderData, ThrowOnError>): RequestResult<CreateBeforeOrderResponses, CreateBeforeOrderErrors, ThrowOnError> => (options.client ?? client).post<CreateBeforeOrderResponses, CreateBeforeOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/before-orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 사전주문 단건 조회
 *
 * 사전주문 단건 조회.
 */
export const getBeforeOrder = <ThrowOnError extends boolean = false>(options: Options<GetBeforeOrderData, ThrowOnError>): RequestResult<GetBeforeOrderResponses, GetBeforeOrderErrors, ThrowOnError> => (options.client ?? client).get<GetBeforeOrderResponses, GetBeforeOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/before-orders/{beforeOrderId}',
    ...options
});

/**
 * 사전주문 더미 결제 완료 (테스트용)
 *
 * 사전주문 더미 결제 완료 (테스트용, PG 없이 주문 생성).
 *
 * <p>체크아웃 완료된 사전주문을 PG 없이 정식 주문으로 전환한다.
 * 포인트 차감, 쿠폰 사용, 적립 포인트 유예 등록이 모두 처리된다.</p>
 */
export const dummyComplete = <ThrowOnError extends boolean = false>(options: Options<DummyCompleteData, ThrowOnError>): RequestResult<DummyCompleteResponses, DummyCompleteErrors, ThrowOnError> => (options.client ?? client).post<DummyCompleteResponses, DummyCompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/before-orders/{beforeOrderId}/dummy-complete',
    ...options
});

/**
 * 장바구니 다건 삭제
 *
 * 장바구니 아이템 다건 삭제.
 */
export const deleteCartItems = <ThrowOnError extends boolean = false>(options: Options<DeleteCartItemsData, ThrowOnError>): RequestResult<DeleteCartItemsResponses, DeleteCartItemsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCartItemsResponses, DeleteCartItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 장바구니 목록 조회
 *
 * 장바구니 목록 조회.
 */
export const findCartItems = <ThrowOnError extends boolean = false>(options?: Options<FindCartItemsData, ThrowOnError>): RequestResult<FindCartItemsResponses, FindCartItemsErrors, ThrowOnError> => (options?.client ?? client).get<FindCartItemsResponses, FindCartItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items',
    ...options
});

/**
 * 장바구니 상품 추가
 *
 * 장바구니 상품 추가.
 */
export const saveCartItem = <ThrowOnError extends boolean = false>(options: Options<SaveCartItemData, ThrowOnError>): RequestResult<SaveCartItemResponses, SaveCartItemErrors, ThrowOnError> => (options.client ?? client).post<SaveCartItemResponses, SaveCartItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 쿠폰 다운로드 가능 여부 조회 (장바구니 배너용)
 *
 * 쿠폰 다운로드 가능 여부 조회.
 */
export const findCouponAvailable = <ThrowOnError extends boolean = false>(options?: Options<FindCouponAvailableData, ThrowOnError>): RequestResult<FindCouponAvailableResponses, FindCouponAvailableErrors, ThrowOnError> => (options?.client ?? client).get<FindCouponAvailableResponses, FindCouponAvailableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items/coupon-available',
    ...options
});

/**
 * 상품 ID로 옵션 목록 조회 (옵션 변경용)
 */
export const getProductOptionsById = <ThrowOnError extends boolean = false>(options: Options<GetProductOptionsByIdData, ThrowOnError>): RequestResult<GetProductOptionsByIdResponses, GetProductOptionsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetProductOptionsByIdResponses, GetProductOptionsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items/product-options/{productId}',
    ...options
});

/**
 * 장바구니 단건 삭제
 *
 * 장바구니 아이템 단건 삭제.
 */
export const deleteCartItem = <ThrowOnError extends boolean = false>(options: Options<DeleteCartItemData, ThrowOnError>): RequestResult<DeleteCartItemResponses, DeleteCartItemErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCartItemResponses, DeleteCartItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items/{cartItemId}',
    ...options
});

/**
 * 장바구니 옵션 변경
 *
 * 장바구니 옵션 변경.
 */
export const updateOption = <ThrowOnError extends boolean = false>(options: Options<UpdateOptionData, ThrowOnError>): RequestResult<UpdateOptionResponses, UpdateOptionErrors, ThrowOnError> => (options.client ?? client).put<UpdateOptionResponses, UpdateOptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items/{cartItemId}/option',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 장바구니 수량 변경
 *
 * 장바구니 수량 변경.
 */
export const updateQuantity = <ThrowOnError extends boolean = false>(options: Options<UpdateQuantityData, ThrowOnError>): RequestResult<UpdateQuantityResponses, UpdateQuantityErrors, ThrowOnError> => (options.client ?? client).put<UpdateQuantityResponses, UpdateQuantityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/cart-items/{cartItemId}/quantity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 사전주문 체크아웃 (배송지 + 구매자 정보 확정)
 *
 * 사전주문 체크아웃 (배송지 + 구매자 정보 확정).
 *
 * <p>배송비를 계산하고 최종 결제 금액을 확정한다.</p>
 */
export const checkout = <ThrowOnError extends boolean = false>(options: Options<CheckoutData, ThrowOnError>): RequestResult<CheckoutResponses, CheckoutErrors, ThrowOnError> => (options.client ?? client).put<CheckoutResponses, CheckoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/checkouts/{beforeOrderId}/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 결제 시 적용 가능한 쿠폰 목록 조회
 *
 * 결제 시 적용 가능한 쿠폰 목록 조회
 */
export const findApplicableCoupons = <ThrowOnError extends boolean = false>(options: Options<FindApplicableCouponsData, ThrowOnError>): RequestResult<FindApplicableCouponsResponses, FindApplicableCouponsErrors, ThrowOnError> => (options.client ?? client).get<FindApplicableCouponsResponses, FindApplicableCouponsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/applicable',
    ...options
});

/**
 * 상품별 적용 가능 쿠폰 조회
 *
 * 상품별 적용 가능 쿠폰 조회
 */
export const findApplicableCouponsForProducts = <ThrowOnError extends boolean = false>(options: Options<FindApplicableCouponsForProductsData, ThrowOnError>): RequestResult<FindApplicableCouponsForProductsResponses, FindApplicableCouponsForProductsErrors, ThrowOnError> => (options.client ?? client).post<FindApplicableCouponsForProductsResponses, FindApplicableCouponsForProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/applicable-for-products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 사용 가능 쿠폰 목록 조회
 *
 * 사용 가능 쿠폰 목록 조회
 */
export const findAvailableCoupons = <ThrowOnError extends boolean = false>(options?: Options<FindAvailableCouponsData, ThrowOnError>): RequestResult<FindAvailableCouponsResponses, FindAvailableCouponsErrors, ThrowOnError> => (options?.client ?? client).get<FindAvailableCouponsResponses, FindAvailableCouponsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/available',
    ...options
});

/**
 * 쿠폰 일괄 다운로드
 *
 * 쿠폰 일괄 다운로드
 */
export const downloadAllCoupons = <ThrowOnError extends boolean = false>(options: Options<DownloadAllCouponsData, ThrowOnError>): RequestResult<DownloadAllCouponsResponses, DownloadAllCouponsErrors, ThrowOnError> => (options.client ?? client).post<DownloadAllCouponsResponses, DownloadAllCouponsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/download-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 다운로드 가능 쿠폰 목록 조회
 *
 * 상품별 다운로드 가능 쿠폰 목록 조회
 */
export const findDownloadableCoupons = <ThrowOnError extends boolean = false>(options: Options<FindDownloadableCouponsData, ThrowOnError>): RequestResult<FindDownloadableCouponsResponses, FindDownloadableCouponsErrors, ThrowOnError> => (options.client ?? client).get<FindDownloadableCouponsResponses, FindDownloadableCouponsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/downloadable',
    ...options
});

/**
 * 다운로드 가능 쿠폰 존재 여부 확인
 *
 * 다운로드 가능 쿠폰 존재 여부 확인
 */
export const existsDownloadableCoupon = <ThrowOnError extends boolean = false>(options: Options<ExistsDownloadableCouponData, ThrowOnError>): RequestResult<ExistsDownloadableCouponResponses, ExistsDownloadableCouponErrors, ThrowOnError> => (options.client ?? client).get<ExistsDownloadableCouponResponses, ExistsDownloadableCouponErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/downloadable/exists',
    ...options
});

/**
 * 내 보유 쿠폰 목록 조회
 *
 * 내 보유 쿠폰 목록 조회
 */
export const findMyCoupons = <ThrowOnError extends boolean = false>(options?: Options<FindMyCouponsData, ThrowOnError>): RequestResult<FindMyCouponsResponses, FindMyCouponsErrors, ThrowOnError> => (options?.client ?? client).get<FindMyCouponsResponses, FindMyCouponsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/my',
    ...options
});

/**
 * 쿠폰 다운로드
 *
 * 쿠폰 개별 다운로드
 */
export const downloadCoupon = <ThrowOnError extends boolean = false>(options: Options<DownloadCouponData, ThrowOnError>): RequestResult<DownloadCouponResponses, DownloadCouponErrors, ThrowOnError> => (options.client ?? client).post<DownloadCouponResponses, DownloadCouponErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/coupons/{couponId}/download',
    ...options
});

/**
 * 내가 쓴 리뷰 목록 조회
 *
 * 내가 쓴 리뷰 목록을 조회한다.
 */
export const findMyReviews = <ThrowOnError extends boolean = false>(options?: Options<FindMyReviewsData, ThrowOnError>): RequestResult<FindMyReviewsResponses, FindMyReviewsErrors, ThrowOnError> => (options?.client ?? client).get<FindMyReviewsResponses, FindMyReviewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews',
    ...options
});

/**
 * 리뷰 작성
 *
 * 주문 상품에 대한 리뷰를 작성한다.
 */
export const saveReview = <ThrowOnError extends boolean = false>(options: Options<SaveReviewData, ThrowOnError>): RequestResult<SaveReviewResponses, SaveReviewErrors, ThrowOnError> => (options.client ?? client).post<SaveReviewResponses, SaveReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 리뷰 작성 폼 조회
 *
 * 리뷰 작성 폼 데이터를 조회한다.
 */
export const getReviewForm = <ThrowOnError extends boolean = false>(options: Options<GetReviewFormData, ThrowOnError>): RequestResult<GetReviewFormResponses, GetReviewFormErrors, ThrowOnError> => (options.client ?? client).get<GetReviewFormResponses, GetReviewFormErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}/form',
    ...options
});

/**
 * 내가 쓴 리뷰 삭제
 *
 * 내 리뷰를 삭제한다.
 */
export const deleteMyReview = <ThrowOnError extends boolean = false>(options: Options<DeleteMyReviewData, ThrowOnError>): RequestResult<DeleteMyReviewResponses, DeleteMyReviewErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMyReviewResponses, DeleteMyReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews/{reviewId}',
    ...options
});

/**
 * 내가 쓴 리뷰 상세 조회
 *
 * 내 리뷰 상세를 조회한다.
 */
export const findMyReview = <ThrowOnError extends boolean = false>(options: Options<FindMyReviewData, ThrowOnError>): RequestResult<FindMyReviewResponses, FindMyReviewErrors, ThrowOnError> => (options.client ?? client).get<FindMyReviewResponses, FindMyReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews/{reviewId}',
    ...options
});

/**
 * 내가 쓴 리뷰 수정
 *
 * 내 리뷰를 수정한다.
 */
export const updateMyReview = <ThrowOnError extends boolean = false>(options: Options<UpdateMyReviewData, ThrowOnError>): RequestResult<UpdateMyReviewResponses, UpdateMyReviewErrors, ThrowOnError> => (options.client ?? client).put<UpdateMyReviewResponses, UpdateMyReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/my/reviews/{reviewId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 간편결제수단 목록 조회
 *
 * 간편결제수단 목록을 조회합니다.
 */
export const findSimplePayMethods = <ThrowOnError extends boolean = false>(options?: Options<FindSimplePayMethodsData, ThrowOnError>): RequestResult<FindSimplePayMethodsResponses, FindSimplePayMethodsErrors, ThrowOnError> => (options?.client ?? client).get<FindSimplePayMethodsResponses, FindSimplePayMethodsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payment-methods',
    ...options
});

/**
 * 결제 승인
 *
 * 결제를 승인합니다.
 *
 * @deprecated
 */
export const approvePayment = <ThrowOnError extends boolean = false>(options: Options<ApprovePaymentData, ThrowOnError>): RequestResult<ApprovePaymentResponses, ApprovePaymentErrors, ThrowOnError> => (options.client ?? client).post<ApprovePaymentResponses, ApprovePaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payments/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 결제 취소
 *
 * 결제를 취소합니다.
 */
export const cancelOrder1 = <ThrowOnError extends boolean = false>(options: Options<CancelOrder1Data, ThrowOnError>): RequestResult<CancelOrder1Responses, CancelOrder1Errors, ThrowOnError> => (options.client ?? client).post<CancelOrder1Responses, CancelOrder1Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payments/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 결제 설정 조회
 *
 * 결제 설정을 조회합니다.
 */
export const findPaymentConfig = <ThrowOnError extends boolean = false>(options?: Options<FindPaymentConfigData, ThrowOnError>): RequestResult<FindPaymentConfigResponses, FindPaymentConfigErrors, ThrowOnError> => (options?.client ?? client).get<FindPaymentConfigResponses, FindPaymentConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payments/config',
    ...options
});

/**
 * 결제 약관 전체 조회
 *
 * 결제 약관 전체(3종)를 조회합니다.
 */
export const findAllTerms = <ThrowOnError extends boolean = false>(options?: Options<FindAllTermsData, ThrowOnError>): RequestResult<FindAllTermsResponses, FindAllTermsErrors, ThrowOnError> => (options?.client ?? client).get<FindAllTermsResponses, FindAllTermsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payments/terms',
    ...options
});

/**
 * 결제 약관 단건 조회
 *
 * 특정 결제 약관을 조회합니다.
 */
export const findTerms = <ThrowOnError extends boolean = false>(options: Options<FindTermsData, ThrowOnError>): RequestResult<FindTermsResponses, FindTermsErrors, ThrowOnError> => (options.client ?? client).get<FindTermsResponses, FindTermsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/payments/terms/{termsType}',
    ...options
});

/**
 * 상품 문의 등록
 *
 * 상품 문의 등록
 */
export const saveInquiry = <ThrowOnError extends boolean = false>(options: Options<SaveInquiryData, ThrowOnError>): RequestResult<SaveInquiryResponses, SaveInquiryErrors, ThrowOnError> => (options.client ?? client).post<SaveInquiryResponses, SaveInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/products/{productId}/inquiries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 상품 문의 삭제
 *
 * 상품 문의 삭제
 */
export const deleteInquiry = <ThrowOnError extends boolean = false>(options: Options<DeleteInquiryData, ThrowOnError>): RequestResult<DeleteInquiryResponses, DeleteInquiryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInquiryResponses, DeleteInquiryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/local-market/products/{productId}/inquiries/{inquiryId}',
    ...options
});

/**
 * 웰로페 참여 정보 조회
 */
export const getLocalfestaParticipantInfo = <ThrowOnError extends boolean = false>(options?: Options<GetLocalfestaParticipantInfoData, ThrowOnError>): RequestResult<GetLocalfestaParticipantInfoResponses, GetLocalfestaParticipantInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetLocalfestaParticipantInfoResponses, GetLocalfestaParticipantInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/localfesta/participant',
    ...options
});

/**
 * 웰로페 참여 등록
 *
 * 종료된 이벤트 — 항상 30400(종료된 이벤트입니다.)으로 거절한다. 본문 검증 실패는 30001 이 먼저 나간다.
 */
export const saveLocalfestaParticipant = <ThrowOnError extends boolean = false>(options: Options<SaveLocalfestaParticipantData, ThrowOnError>): RequestResult<SaveLocalfestaParticipantResponses, SaveLocalfestaParticipantErrors, ThrowOnError> => (options.client ?? client).post<SaveLocalfestaParticipantResponses, SaveLocalfestaParticipantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/localfesta/participant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로페 입장하기
 *
 * 종료된 이벤트 — 항상 30400(종료된 이벤트입니다.)으로 거절한다.
 */
export const updateLocalfestaParticipantEntry = <ThrowOnError extends boolean = false>(options?: Options<UpdateLocalfestaParticipantEntryData, ThrowOnError>): RequestResult<UpdateLocalfestaParticipantEntryResponses, UpdateLocalfestaParticipantEntryErrors, ThrowOnError> => (options?.client ?? client).put<UpdateLocalfestaParticipantEntryResponses, UpdateLocalfestaParticipantEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/localfesta/participant/entry',
    ...options
});

/**
 * 회원 탈퇴
 *
 * 회원 탈퇴요청을 처리합니다
 */
export const resignMember = <ThrowOnError extends boolean = false>(options: Options<ResignMemberData, ThrowOnError>): RequestResult<ResignMemberResponses, ResignMemberErrors, ThrowOnError> => (options.client ?? client).delete<ResignMemberResponses, ResignMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 유저 프로필 이미지 업로드
 *
 * 유저 프로필 이미지를 업로드 한다.
 */
export const fileUpload1 = <ThrowOnError extends boolean = false>(options?: Options<FileUpload1Data, ThrowOnError>): RequestResult<FileUpload1Responses, FileUpload1Errors, ThrowOnError> => (options?.client ?? client).post<FileUpload1Responses, FileUpload1Errors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * 맞춤 정보 저장
 */
export const putFitFilter = <ThrowOnError extends boolean = false>(options: Options<PutFitFilterData, ThrowOnError>): RequestResult<PutFitFilterResponses, PutFitFilterErrors, ThrowOnError> => (options.client ?? client).post<PutFitFilterResponses, PutFitFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/fit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 회원가입 맞춤 정보 저장
 */
export const saveFitFilter = <ThrowOnError extends boolean = false>(options: Options<SaveFitFilterData, ThrowOnError>): RequestResult<SaveFitFilterResponses, SaveFitFilterErrors, ThrowOnError> => (options.client ?? client).post<SaveFitFilterResponses, SaveFitFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/fit-new',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 관심 필터 조회
 */
export const interestFilter = <ThrowOnError extends boolean = false>(options?: Options<InterestFilterData, ThrowOnError>): RequestResult<InterestFilterResponses, InterestFilterErrors, ThrowOnError> => (options?.client ?? client).get<InterestFilterResponses, InterestFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/interest',
    ...options
});

/**
 * 관심 필터 코드 저장
 */
export const saveInterestFilter = <ThrowOnError extends boolean = false>(options: Options<SaveInterestFilterData, ThrowOnError>): RequestResult<SaveInterestFilterResponses, SaveInterestFilterErrors, ThrowOnError> => (options.client ?? client).post<SaveInterestFilterResponses, SaveInterestFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/interest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 *  KB 기본 필터 저장
 */
export const saveKbFilter = <ThrowOnError extends boolean = false>(options: Options<SaveKbFilterData, ThrowOnError>): RequestResult<SaveKbFilterResponses, SaveKbFilterErrors, ThrowOnError> => (options.client ?? client).post<SaveKbFilterResponses, SaveKbFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/kb',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지역 필터 저장
 */
export const noticeList = <ThrowOnError extends boolean = false>(options: Options<NoticeListData, ThrowOnError>): RequestResult<NoticeListResponses, NoticeListErrors, ThrowOnError> => (options.client ?? client).post<NoticeListResponses, NoticeListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/region',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 필터 조회(관심필터 제외)
 */
export const requiredFilter = <ThrowOnError extends boolean = false>(options?: Options<RequiredFilterData, ThrowOnError>): RequestResult<RequiredFilterResponses, RequiredFilterErrors, ThrowOnError> => (options?.client ?? client).get<RequiredFilterResponses, RequiredFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-filter/required',
    ...options
});

/**
 * identityKey 조회
 *
 * 본인인증 정보가 없으면 returnCode 30404를 반환합니다.
 */
export const findMemberIdentity = <ThrowOnError extends boolean = false>(options?: Options<FindMemberIdentityData, ThrowOnError>): RequestResult<FindMemberIdentityResponses, FindMemberIdentityErrors, ThrowOnError> => (options?.client ?? client).get<FindMemberIdentityResponses, FindMemberIdentityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-identity',
    ...options
});

export const logoutMember = <ThrowOnError extends boolean = false>(options?: Options<LogoutMemberData, ThrowOnError>): RequestResult<LogoutMemberResponses, LogoutMemberErrors, ThrowOnError> => (options?.client ?? client).post<LogoutMemberResponses, LogoutMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-oauth/logout',
    ...options
});

export const getMember = <ThrowOnError extends boolean = false>(options?: Options<GetMemberData, ThrowOnError>): RequestResult<GetMemberResponses, GetMemberErrors, ThrowOnError> => (options?.client ?? client).get<GetMemberResponses, GetMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-oauth/my-info',
    ...options
});

/**
 * 약관 동의 여부 조회
 */
export const getMemberTermAgreementByAgreementType = <ThrowOnError extends boolean = false>(options: Options<GetMemberTermAgreementByAgreementTypeData, ThrowOnError>): RequestResult<GetMemberTermAgreementByAgreementTypeResponses, GetMemberTermAgreementByAgreementTypeErrors, ThrowOnError> => (options.client ?? client).get<GetMemberTermAgreementByAgreementTypeResponses, GetMemberTermAgreementByAgreementTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-term-agreement',
    ...options
});

/**
 * 약관 동의 저장/수정
 */
export const saveOrUpdateMemberTermAgreement = <ThrowOnError extends boolean = false>(options: Options<SaveOrUpdateMemberTermAgreementData, ThrowOnError>): RequestResult<SaveOrUpdateMemberTermAgreementResponses, SaveOrUpdateMemberTermAgreementErrors, ThrowOnError> => (options.client ?? client).post<SaveOrUpdateMemberTermAgreementResponses, SaveOrUpdateMemberTermAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-term-agreement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 최근 인증된 멤버 CI 조회
 */
export const getLatestCompletedCi = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCompletedCiData, ThrowOnError>): RequestResult<GetLatestCompletedCiResponses, GetLatestCompletedCiErrors, ThrowOnError> => (options?.client ?? client).post<GetLatestCompletedCiResponses, GetLatestCompletedCiErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-verification',
    ...options
});

/**
 * 본인인증 ID 조회
 */
export const getMemberVerificationId = <ThrowOnError extends boolean = false>(options?: Options<GetMemberVerificationIdData, ThrowOnError>): RequestResult<GetMemberVerificationIdResponses, GetMemberVerificationIdErrors, ThrowOnError> => (options?.client ?? client).get<GetMemberVerificationIdResponses, GetMemberVerificationIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-verification/check',
    ...options
});

/**
 * 본인인증 정보 복호화
 */
export const decryptMemberVerification = <ThrowOnError extends boolean = false>(options: Options<DecryptMemberVerificationData, ThrowOnError>): RequestResult<DecryptMemberVerificationResponses, DecryptMemberVerificationErrors, ThrowOnError> => (options.client ?? client).post<DecryptMemberVerificationResponses, DecryptMemberVerificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-verification/decrypt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 최근 인증된 멤버 정보 조회
 */
export const getLatestCompleted = <ThrowOnError extends boolean = false>(options?: Options<GetLatestCompletedData, ThrowOnError>): RequestResult<GetLatestCompletedResponses, GetLatestCompletedErrors, ThrowOnError> => (options?.client ?? client).post<GetLatestCompletedResponses, GetLatestCompletedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-verification/info',
    ...options
});

/**
 * 멤버 상세 정보 조회
 */
export const getMemberDetailInfo = <ThrowOnError extends boolean = false>(options?: Options<GetMemberDetailInfoData, ThrowOnError>): RequestResult<GetMemberDetailInfoResponses, GetMemberDetailInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetMemberDetailInfoResponses, GetMemberDetailInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-verification/info/detail',
    ...options
});

/**
 * 웰로 사용자 차단 목록 조회
 */
export const getWelloMemberBlockList = <ThrowOnError extends boolean = false>(options: Options<GetWelloMemberBlockListData, ThrowOnError>): RequestResult<GetWelloMemberBlockListResponses, GetWelloMemberBlockListErrors, ThrowOnError> => (options.client ?? client).get<GetWelloMemberBlockListResponses, GetWelloMemberBlockListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/block',
    ...options
});

/**
 * 웰로 사용자 차단 - By Community
 */
export const blockWelloMemberByCommunity = <ThrowOnError extends boolean = false>(options: Options<BlockWelloMemberByCommunityData, ThrowOnError>): RequestResult<BlockWelloMemberByCommunityResponses, BlockWelloMemberByCommunityErrors, ThrowOnError> => (options.client ?? client).post<BlockWelloMemberByCommunityResponses, BlockWelloMemberByCommunityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/block/by-community/{communityId}',
    ...options
});

/**
 * 웰로 사용자 차단 해제 - 삭제
 */
export const deleteMemberWelloBlock = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberWelloBlockData, ThrowOnError>): RequestResult<DeleteMemberWelloBlockResponses, DeleteMemberWelloBlockErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemberWelloBlockResponses, DeleteMemberWelloBlockErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/block/{blockedMemberId}',
    ...options
});

/**
 * 위치 기반 동의 여부 조회
 */
export const getLocationServiceConsent = <ThrowOnError extends boolean = false>(options?: Options<GetLocationServiceConsentData, ThrowOnError>): RequestResult<GetLocationServiceConsentResponses, GetLocationServiceConsentErrors, ThrowOnError> => (options?.client ?? client).get<GetLocationServiceConsentResponses, GetLocationServiceConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/location-service-consent',
    ...options
});

/**
 * 위치 기반 동의 여부 수정
 */
export const updateLocationServiceConsent = <ThrowOnError extends boolean = false>(options: Options<UpdateLocationServiceConsentData, ThrowOnError>): RequestResult<UpdateLocationServiceConsentResponses, UpdateLocationServiceConsentErrors, ThrowOnError> => (options.client ?? client).put<UpdateLocationServiceConsentResponses, UpdateLocationServiceConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/location-service-consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 개인 정보 수집 동의 여부 조회
 */
export const getPrivateDataConsent = <ThrowOnError extends boolean = false>(options?: Options<GetPrivateDataConsentData, ThrowOnError>): RequestResult<GetPrivateDataConsentResponses, GetPrivateDataConsentErrors, ThrowOnError> => (options?.client ?? client).get<GetPrivateDataConsentResponses, GetPrivateDataConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/private_data_consent',
    ...options
});

/**
 * 개인 정보 수집 동의 여부 수정
 */
export const updatePrivateDataConsent = <ThrowOnError extends boolean = false>(options: Options<UpdatePrivateDataConsentData, ThrowOnError>): RequestResult<UpdatePrivateDataConsentResponses, UpdatePrivateDataConsentErrors, ThrowOnError> => (options.client ?? client).put<UpdatePrivateDataConsentResponses, UpdatePrivateDataConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member-wello/private_data_consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 유저의 행동 관련 수치 조회
 *
 * 유저의 맞춤 정책, 스크랩 목록 수를 조회합니다.
 */
export const getActionCount = <ThrowOnError extends boolean = false>(options?: Options<GetActionCountData, ThrowOnError>): RequestResult<GetActionCountResponses, GetActionCountErrors, ThrowOnError> => (options?.client ?? client).get<GetActionCountResponses, GetActionCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/action-count',
    ...options
});

/**
 * 메인 페이지 멤버 컨텐츠 별 건수
 */
export const memberContentCount = <ThrowOnError extends boolean = false>(options?: Options<MemberContentCountData, ThrowOnError>): RequestResult<MemberContentCountResponses, MemberContentCountErrors, ThrowOnError> => (options?.client ?? client).get<MemberContentCountResponses, MemberContentCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/content-count',
    ...options
});

/**
 * 유저가 초대한 회원 수 조회
 */
export const getInvitedMemberCount = <ThrowOnError extends boolean = false>(options?: Options<GetInvitedMemberCountData, ThrowOnError>): RequestResult<GetInvitedMemberCountResponses, GetInvitedMemberCountErrors, ThrowOnError> => (options?.client ?? client).get<GetInvitedMemberCountResponses, GetInvitedMemberCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/invited-member-count',
    ...options
});

/**
 * KB 연동 체크
 */
export const kbMemberCheck = <ThrowOnError extends boolean = false>(options: Options<KbMemberCheckData, ThrowOnError>): RequestResult<KbMemberCheckResponses, KbMemberCheckErrors, ThrowOnError> => (options.client ?? client).post<KbMemberCheckResponses, KbMemberCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/kb-member-check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const messageReceive = <ThrowOnError extends boolean = false>(options: Options<MessageReceiveData, ThrowOnError>): RequestResult<MessageReceiveResponses, MessageReceiveErrors, ThrowOnError> => (options.client ?? client).put<MessageReceiveResponses, MessageReceiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/message-receive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 우리 동네 이웃이 많이 본 정책 조회
 */
export const memberNeighborPolicyList = <ThrowOnError extends boolean = false>(options?: Options<MemberNeighborPolicyListData, ThrowOnError>): RequestResult<MemberNeighborPolicyListResponses, MemberNeighborPolicyListErrors, ThrowOnError> => (options?.client ?? client).get<MemberNeighborPolicyListResponses, MemberNeighborPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/neighbor/policy',
    ...options
});

/**
 * 내 또래가 많이 본 정책 조회
 */
export const memberPeerGroupPolicyList = <ThrowOnError extends boolean = false>(options?: Options<MemberPeerGroupPolicyListData, ThrowOnError>): RequestResult<MemberPeerGroupPolicyListResponses, MemberPeerGroupPolicyListErrors, ThrowOnError> => (options?.client ?? client).get<MemberPeerGroupPolicyListResponses, MemberPeerGroupPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/peer-group/policy',
    ...options
});

/**
 * 지원유형별 맞춤정책 건수
 *
 * 지원유형별 맞춤정책 건수를 조회합니다
 */
export const memberPolicyList = <ThrowOnError extends boolean = false>(options?: Options<MemberPolicyListData, ThrowOnError>): RequestResult<MemberPolicyListResponses, MemberPolicyListErrors, ThrowOnError> => (options?.client ?? client).get<MemberPolicyListResponses, MemberPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/policy/provision-type-count',
    ...options
});

/**
 * 유저 프로필 조회
 *
 * 가입된 유저의 프로필을 조회합니다
 */
export const member = <ThrowOnError extends boolean = false>(options?: Options<MemberData, ThrowOnError>): RequestResult<MemberResponses, MemberErrors, ThrowOnError> => (options?.client ?? client).get<MemberResponses, MemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/profile',
    ...options
});

/**
 * 유저 가입정보 등록
 */
export const saveMemberNickName = <ThrowOnError extends boolean = false>(options: Options<SaveMemberNickNameData, ThrowOnError>): RequestResult<SaveMemberNickNameResponses, SaveMemberNickNameErrors, ThrowOnError> => (options.client ?? client).post<SaveMemberNickNameResponses, SaveMemberNickNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 유저 정보 수정
 *
 * 가입된 유저 정보를 수정합니다
 */
export const updateMemberNickName = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberNickNameData, ThrowOnError>): RequestResult<UpdateMemberNickNameResponses, UpdateMemberNickNameErrors, ThrowOnError> => (options.client ?? client).put<UpdateMemberNickNameResponses, UpdateMemberNickNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 내가 본 정책과 비슷한 정책 조회
 */
export const memberRecommendPolicyByRecentList = <ThrowOnError extends boolean = false>(options?: Options<MemberRecommendPolicyByRecentListData, ThrowOnError>): RequestResult<MemberRecommendPolicyByRecentListResponses, MemberRecommendPolicyByRecentListErrors, ThrowOnError> => (options?.client ?? client).get<MemberRecommendPolicyByRecentListResponses, MemberRecommendPolicyByRecentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/recent/recommend/policy',
    ...options
});

/**
 * 연동된 소셜계정 목록
 */
export const memberSocialAccounts = <ThrowOnError extends boolean = false>(options?: Options<MemberSocialAccountsData, ThrowOnError>): RequestResult<MemberSocialAccountsResponses, MemberSocialAccountsErrors, ThrowOnError> => (options?.client ?? client).get<MemberSocialAccountsResponses, MemberSocialAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/social-accounts',
    ...options
});

/**
 * 유저 프로필 조회
 *
 * 가입된 유저의 프로필을 조회합니다
 */
export const userProperty = <ThrowOnError extends boolean = false>(options?: Options<UserPropertyData, ThrowOnError>): RequestResult<UserPropertyResponses, UserPropertyErrors, ThrowOnError> => (options?.client ?? client).get<UserPropertyResponses, UserPropertyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/user-property',
    ...options
});

/**
 * 본인인증 ID로 유저정보 수정
 */
export const updateMemberVerification = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberVerificationData, ThrowOnError>): RequestResult<UpdateMemberVerificationResponses, UpdateMemberVerificationErrors, ThrowOnError> => (options.client ?? client).put<UpdateMemberVerificationResponses, UpdateMemberVerificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 스크랩 삭제
 */
export const deleteWishlist = <ThrowOnError extends boolean = false>(options: Options<DeleteWishlistData, ThrowOnError>): RequestResult<DeleteWishlistResponses, DeleteWishlistErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWishlistResponses, DeleteWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 스크랩 등록
 */
export const saveWishlist = <ThrowOnError extends boolean = false>(options: Options<SaveWishlistData, ThrowOnError>): RequestResult<SaveWishlistResponses, SaveWishlistErrors, ThrowOnError> => (options.client ?? client).post<SaveWishlistResponses, SaveWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 정책소식 스크랩 목록 조회
 */
export const bestContentsWishlist = <ThrowOnError extends boolean = false>(options?: Options<BestContentsWishlistData, ThrowOnError>): RequestResult<BestContentsWishlistResponses, BestContentsWishlistErrors, ThrowOnError> => (options?.client ?? client).get<BestContentsWishlistResponses, BestContentsWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/best-contents',
    ...options
});

/**
 * 커뮤니티 스크랩 목록 조회 - 웰로소식
 */
export const getCommunityWelloNewsWishlist = <ThrowOnError extends boolean = false>(options?: Options<GetCommunityWelloNewsWishlistData, ThrowOnError>): RequestResult<GetCommunityWelloNewsWishlistResponses, GetCommunityWelloNewsWishlistErrors, ThrowOnError> => (options?.client ?? client).get<GetCommunityWelloNewsWishlistResponses, GetCommunityWelloNewsWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/community/wello-news',
    ...options
});

/**
 * 응급실 스크랩 목록 조회
 */
export const getEmergencyRoomWishlist = <ThrowOnError extends boolean = false>(options?: Options<GetEmergencyRoomWishlistData, ThrowOnError>): RequestResult<GetEmergencyRoomWishlistResponses, GetEmergencyRoomWishlistErrors, ThrowOnError> => (options?.client ?? client).get<GetEmergencyRoomWishlistResponses, GetEmergencyRoomWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/emergency-room',
    ...options
});

/**
 * 동네소식 스크랩 목록 조회
 */
export const hometownNewsWishlist = <ThrowOnError extends boolean = false>(options?: Options<HometownNewsWishlistData, ThrowOnError>): RequestResult<HometownNewsWishlistResponses, HometownNewsWishlistErrors, ThrowOnError> => (options?.client ?? client).get<HometownNewsWishlistResponses, HometownNewsWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/hometown-news',
    ...options
});

/**
 * 정책 스크랩 목록 조회
 */
export const metaPolicyWishlist = <ThrowOnError extends boolean = false>(options?: Options<MetaPolicyWishlistData, ThrowOnError>): RequestResult<MetaPolicyWishlistResponses, MetaPolicyWishlistErrors, ThrowOnError> => (options?.client ?? client).get<MetaPolicyWishlistResponses, MetaPolicyWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/policy',
    ...options
});

/**
 * 축제 스크랩 목록 조회
 */
export const getTourFestivalWishlist = <ThrowOnError extends boolean = false>(options?: Options<GetTourFestivalWishlistData, ThrowOnError>): RequestResult<GetTourFestivalWishlistResponses, GetTourFestivalWishlistErrors, ThrowOnError> => (options?.client ?? client).get<GetTourFestivalWishlistResponses, GetTourFestivalWishlistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/member/wishlist/tour-festival',
    ...options
});

export const rejectMessage = <ThrowOnError extends boolean = false>(options: Options<RejectMessageData, ThrowOnError>): RequestResult<RejectMessageResponses, RejectMessageErrors, ThrowOnError> => (options.client ?? client).put<RejectMessageResponses, RejectMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/message-reject/member-wello',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nice SafeKey 발급요청
 */
export const sendNiceSafeKey = <ThrowOnError extends boolean = false>(options: Options<SendNiceSafeKeyData, ThrowOnError>): RequestResult<SendNiceSafeKeyResponses, SendNiceSafeKeyErrors, ThrowOnError> => (options.client ?? client).post<SendNiceSafeKeyResponses, SendNiceSafeKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/nice-safe-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSendResult = <ThrowOnError extends boolean = false>(options?: Options<CheckPlusSendResultData, ThrowOnError>): RequestResult<CheckPlusSendResultResponses, CheckPlusSendResultErrors, ThrowOnError> => (options?.client ?? client).get<CheckPlusSendResultResponses, CheckPlusSendResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/nice-safe-key/check-plus-send-result',
    ...options
});

/**
 * Nice 신용인증 실패시 이동될 URL
 */
export const checkPlusFail = <ThrowOnError extends boolean = false>(options?: Options<CheckPlusFailData, ThrowOnError>): RequestResult<CheckPlusFailResponses, CheckPlusFailErrors, ThrowOnError> => (options?.client ?? client).get<CheckPlusFailResponses, CheckPlusFailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/nice-safe-key/check-plus_fail',
    ...options
});

/**
 * 룰렛 참여(추첨)
 *
 * 당첨 등급을 확정해 반환합니다(1인 1회, 재호출은 기존 결과를 firstDrawYN=false 로 반환). 진행 중인 이벤트가 없으면 30404, 기간 밖·자격 미달·마케팅 수신동의 미동의·경품 소진은 30400 입니다. 쿠폰 지급은 비동기이고 실물 경품은 개별 연락 대상입니다.
 *
 * 쿼리 파라미터 epayNo(전자납부번호)는 **선택**입니다. 넘기면 그 기부건을 자격 근거로 쓰고, 유효하지 않으면(본인 것이 아니거나 자격 조건 미달) 에러가 아니라 자동 선택(가장 이른 자격 기부)으로 폴백합니다. 1인 1회라 참여 횟수에는 영향이 없고 감사 근거(어느 기부로 참여했는지)만 정확해집니다. 생략하면 기존과 동일하게 서버가 자동 선택합니다.
 */
export const drawNonsanRoulette = <ThrowOnError extends boolean = false>(options?: Options<DrawNonsanRouletteData, ThrowOnError>): RequestResult<DrawNonsanRouletteResponses, DrawNonsanRouletteErrors, ThrowOnError> => (options?.client ?? client).post<DrawNonsanRouletteResponses, DrawNonsanRouletteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/nonsan-roulette/draw',
    ...options
});

/**
 * 내 참여 자격·상태 조회
 *
 * 참여 상태(participationStatus)와 내 당첨 결과를 반환합니다. participationStatus 가 FE 분기의 단일 출처이며 우선순위는 이미 참여 > 기간 > 소진 > 자격 입니다. 진행 중인 이벤트가 없으면 30404. soldOutAt 은 전 등급 소진 시에만 값이 있습니다.
 */
export const findNonsanRouletteStatus = <ThrowOnError extends boolean = false>(options?: Options<FindNonsanRouletteStatusData, ThrowOnError>): RequestResult<FindNonsanRouletteStatusResponses, FindNonsanRouletteStatusErrors, ThrowOnError> => (options?.client ?? client).get<FindNonsanRouletteStatusResponses, FindNonsanRouletteStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/nonsan-roulette/status',
    ...options
});

/**
 * 포인트 정보 조회
 *
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getDetailPointBalance = <ThrowOnError extends boolean = false>(options?: Options<GetDetailPointBalanceData, ThrowOnError>): RequestResult<GetDetailPointBalanceResponses, GetDetailPointBalanceErrors, ThrowOnError> => (options?.client ?? client).get<GetDetailPointBalanceResponses, GetDetailPointBalanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point',
    ...options
});

/**
 * 주문 목록 조회
 *
 * 요청한 페이지의 주문 상태를 최신화(사용 전 만료, 발급 완료는 다우 쿠폰 사용·폐기 반영 후 만료)해 응답한다. 다우 조회가 실패한 주문은 건너뛰고 기존 상태로 응답한다(다우 통신 오류가 나면 남은 주문도 기존 상태).
 */
export const getPointMarketOrderList = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketOrderListData, ThrowOnError>): RequestResult<GetPointMarketOrderListResponses, GetPointMarketOrderListErrors, ThrowOnError> => (options?.client ?? client).get<GetPointMarketOrderListResponses, GetPointMarketOrderListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order',
    ...options
});

/**
 * 주문 결제
 *
 * 마케팅 수신 동의 회원만 주문할 수 있다 — 미동의면 포인트를 차감하지 않고 30400 "마케팅 수신 동의 후 이용할 수 있어요.".
 */
export const payPointMarketOrder = <ThrowOnError extends boolean = false>(options: Options<PayPointMarketOrderData, ThrowOnError>): RequestResult<PayPointMarketOrderResponses, PayPointMarketOrderErrors, ThrowOnError> => (options.client ?? client).post<PayPointMarketOrderResponses, PayPointMarketOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 결제 전 정보 조회
 */
export const getPointMarketOrderPreview = <ThrowOnError extends boolean = false>(options: Options<GetPointMarketOrderPreviewData, ThrowOnError>): RequestResult<GetPointMarketOrderPreviewResponses, GetPointMarketOrderPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetPointMarketOrderPreviewResponses, GetPointMarketOrderPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order/preview',
    ...options
});

/**
 * 쿠폰 재발송 (deprecated — 사용하기 API 로 대체)
 *
 * @deprecated
 */
export const reissueCoupon = <ThrowOnError extends boolean = false>(options: Options<ReissueCouponData, ThrowOnError>): RequestResult<ReissueCouponResponses, ReissueCouponErrors, ThrowOnError> => (options.client ?? client).post<ReissueCouponResponses, ReissueCouponErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order/reissue-coupon',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 주문 상태 최신화
 *
 * 로그인 회원의 사용 전 주문은 만료일이 지나면 만료로, 발급 완료 주문은 다우 쿠폰이 사용·폐기면 사용 완료·취소로(만료보다 우선), 그 밖의 상태면 만료일이 지났을 때 만료로 바꾼다. 다우 조회가 실패한 주문은 건너뛰고(다우 통신 오류가 나면 남은 주문도 건너뜀) 성공으로 응답한다. 웰마켙 통합 주문목록 조회 전에 호출한다(포인트마켓 주문 목록 조회는 자체적으로 최신화하므로 호출하지 않아도 된다).
 */
export const updatePointMarketOrderStatusList = <ThrowOnError extends boolean = false>(options?: Options<UpdatePointMarketOrderStatusListData, ThrowOnError>): RequestResult<UpdatePointMarketOrderStatusListResponses, UpdatePointMarketOrderStatusListErrors, ThrowOnError> => (options?.client ?? client).put<UpdatePointMarketOrderStatusListResponses, UpdatePointMarketOrderStatusListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order/status',
    ...options
});

/**
 * 사용하기 (쿠폰 발급)
 *
 * 구매 시 사전 저장된 쿠폰을 다우에 발급하고 MMS 를 보낸 뒤 쿠폰 번호를 반환한다. 이미 발급된 주문은 저장된 쿠폰 번호를 반환한다. 만료 시 30400 "만료된 상품입니다.", 다우 발급 실패 시 30400 "현재 주문을 처리할 수 없습니다. 잠시 후 다시 시도해 주세요.", 주문이 없거나 본인 주문이 아니면 30404.
 */
export const issuePointMarketCoupon = <ThrowOnError extends boolean = false>(options: Options<IssuePointMarketCouponData, ThrowOnError>): RequestResult<IssuePointMarketCouponResponses, IssuePointMarketCouponErrors, ThrowOnError> => (options.client ?? client).post<IssuePointMarketCouponResponses, IssuePointMarketCouponErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/order/{orderIdIdx}/coupon',
    ...options
});

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProduct = <ThrowOnError extends boolean = false>(options: Options<FeedbackPointMarketProductData, ThrowOnError>): RequestResult<FeedbackPointMarketProductResponses, FeedbackPointMarketProductErrors, ThrowOnError> => (options.client ?? client).post<FeedbackPointMarketProductResponses, FeedbackPointMarketProductErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point-market/product/{productIdIdx}/feedback',
    ...options
});

/**
 * 출석 내역 조회
 *
 * [Deprecated] WEL-5303 혜택탭 출석체크로 대체 예정. 출석 내역 목록을 조회합니다.
 *
 * @deprecated
 */
export const getListPointAttendance = <ThrowOnError extends boolean = false>(options?: Options<GetListPointAttendanceData, ThrowOnError>): RequestResult<GetListPointAttendanceResponses, GetListPointAttendanceErrors, ThrowOnError> => (options?.client ?? client).get<GetListPointAttendanceResponses, GetListPointAttendanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point/attendance',
    ...options
});

/**
 * 출석 체크
 *
 * [Deprecated] WEL-5303 혜택탭 출석체크로 대체 예정. 오늘 날짜로 출석 내역을 저장합니다.
 *
 * @deprecated
 */
export const saveTodayAttendance = <ThrowOnError extends boolean = false>(options?: Options<SaveTodayAttendanceData, ThrowOnError>): RequestResult<SaveTodayAttendanceResponses, SaveTodayAttendanceErrors, ThrowOnError> => (options?.client ?? client).post<SaveTodayAttendanceResponses, SaveTodayAttendanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point/attendance',
    ...options
});

/**
 * 쿠팡 광고 배너 클릭 적립
 *
 * 쿠팡 광고 배너 클릭 시 고정 2P를 적립합니다. 직전 적립 후 2시간 이내이거나 당일 적립이 5회에 도달하면 returnCode 30400(아직 재참여할 수 없어요)을 반환합니다.
 */
export const rewardCoupangBannerClick = <ThrowOnError extends boolean = false>(options?: Options<RewardCoupangBannerClickData, ThrowOnError>): RequestResult<RewardCoupangBannerClickResponses, RewardCoupangBannerClickErrors, ThrowOnError> => (options?.client ?? client).post<RewardCoupangBannerClickResponses, RewardCoupangBannerClickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point/coupang-banner',
    ...options
});

/**
 * 쿠팡 광고 배너 재참여 가능 시간 조회
 *
 * 적립 불가 여부와 재지급 가능 시각, 1회 적립 포인트와 하루 최대 적립 횟수를 조회합니다. 2시간 쿨다운 미경과면 직전 적립 + 2시간, 당일 5회 소진이면 다음 자정을 반환하며, 지급 가능 상태면 nextAvailableAt 은 null 입니다.
 */
export const getCoupangBannerStatus = <ThrowOnError extends boolean = false>(options?: Options<GetCoupangBannerStatusData, ThrowOnError>): RequestResult<GetCoupangBannerStatusResponses, GetCoupangBannerStatusErrors, ThrowOnError> => (options?.client ?? client).get<GetCoupangBannerStatusResponses, GetCoupangBannerStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point/coupang-banner/status',
    ...options
});

/**
 * 포인트 사용, 출금, 차감 내역 조회
 *
 * 포인트 사용, 출금, 차감 내역 목록을 조회합니다.
 */
export const getListPointHistory = <ThrowOnError extends boolean = false>(options: Options<GetListPointHistoryData, ThrowOnError>): RequestResult<GetListPointHistoryResponses, GetListPointHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetListPointHistoryResponses, GetListPointHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/point/history',
    ...options
});

/**
 * 정책 바로신청 체크
 */
export const checkWelloPolicyApply = <ThrowOnError extends boolean = false>(options: Options<CheckWelloPolicyApplyData, ThrowOnError>): RequestResult<CheckWelloPolicyApplyResponses, CheckWelloPolicyApplyErrors, ThrowOnError> => (options.client ?? client).get<CheckWelloPolicyApplyResponses, CheckWelloPolicyApplyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy-apply/check',
    ...options
});

/**
 * 정책 바로신청 내역 조회
 */
export const getWelloPolicyApplyList = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPolicyApplyListData, ThrowOnError>): RequestResult<GetWelloPolicyApplyListResponses, GetWelloPolicyApplyListErrors, ThrowOnError> => (options?.client ?? client).get<GetWelloPolicyApplyListResponses, GetWelloPolicyApplyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy-apply/history',
    ...options
});

/**
 * 정책 바로신청 내역 수
 */
export const getWelloPolicyApplyCount = <ThrowOnError extends boolean = false>(options?: Options<GetWelloPolicyApplyCountData, ThrowOnError>): RequestResult<GetWelloPolicyApplyCountResponses, GetWelloPolicyApplyCountErrors, ThrowOnError> => (options?.client ?? client).get<GetWelloPolicyApplyCountResponses, GetWelloPolicyApplyCountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy-apply/history/count',
    ...options
});

/**
 * 채무자신고 내역 저장 (각종 정보 제공 동의 및 채무자신고내역 저장)
 */
export const saveReport = <ThrowOnError extends boolean = false>(options: Options<SaveReportData, ThrowOnError>): RequestResult<SaveReportResponses, SaveReportErrors, ThrowOnError> => (options.client ?? client).post<SaveReportResponses, SaveReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy-apply/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedback = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyFeedbackData, ThrowOnError>): RequestResult<MetaPolicyFeedbackResponses, MetaPolicyFeedbackErrors, ThrowOnError> => (options.client ?? client).get<MetaPolicyFeedbackResponses, MetaPolicyFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy/feedback/{policyId}',
    ...options
});

/**
 * 관심 분야별 정책 조회
 */
export const getInterestPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetInterestPolicyListData, ThrowOnError>): RequestResult<GetInterestPolicyListResponses, GetInterestPolicyListErrors, ThrowOnError> => (options.client ?? client).get<GetInterestPolicyListResponses, GetInterestPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/policy/interest-policy',
    ...options
});

/**
 * 설문 통합 조회
 *
 * 투표 여부에 따라 투표 화면(pollDetail) 또는 결과 화면(pollResult) 데이터를 반환합니다
 */
export const getPoll = <ThrowOnError extends boolean = false>(options: Options<GetPollData, ThrowOnError>): RequestResult<GetPollResponses, GetPollErrors, ThrowOnError> => (options.client ?? client).get<GetPollResponses, GetPollErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/poll/{pollId}',
    ...options
});

/**
 * 투표 결과 조회
 *
 * 설문 투표 결과를 질문별로 조회합니다
 */
export const getPollResult = <ThrowOnError extends boolean = false>(options: Options<GetPollResultData, ThrowOnError>): RequestResult<GetPollResultResponses, GetPollResultErrors, ThrowOnError> => (options.client ?? client).get<GetPollResultResponses, GetPollResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/poll/{pollId}/result',
    ...options
});

/**
 * 투표하기
 *
 * 설문에 투표합니다 (전체 질문 답변 한번에 제출)
 */
export const createPollVote = <ThrowOnError extends boolean = false>(options: Options<CreatePollVoteData, ThrowOnError>): RequestResult<CreatePollVoteResponses, CreatePollVoteErrors, ThrowOnError> => (options.client ?? client).post<CreatePollVoteResponses, CreatePollVoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/poll/{pollId}/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 투표 여부 확인
 *
 * 해당 설문에 본인이 투표했는지 확인합니다 (화면 분기용)
 */
export const checkVoted = <ThrowOnError extends boolean = false>(options: Options<CheckVotedData, ThrowOnError>): RequestResult<CheckVotedResponses, CheckVotedErrors, ThrowOnError> => (options.client ?? client).get<CheckVotedResponses, CheckVotedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/poll/{pollId}/voted',
    ...options
});

/**
 * 멤버/가족 신청가능한 맞춤정책 조회
 */
export const recommendPolicyList = <ThrowOnError extends boolean = false>(options: Options<RecommendPolicyListData, ThrowOnError>): RequestResult<RecommendPolicyListResponses, RecommendPolicyListErrors, ThrowOnError> => (options.client ?? client).get<RecommendPolicyListResponses, RecommendPolicyListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/recommend-policy',
    ...options
});

/**
 * 파일 삭제
 */
export const fileDelete = <ThrowOnError extends boolean = false>(options: Options<FileDeleteData, ThrowOnError>): RequestResult<FileDeleteResponses, FileDeleteErrors, ThrowOnError> => (options.client ?? client).delete<FileDeleteResponses, FileDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 업로드
 */
export const fileUpload = <ThrowOnError extends boolean = false>(options?: Options<FileUploadData, ThrowOnError>): RequestResult<FileUploadResponses, FileUploadErrors, ThrowOnError> => (options?.client ?? client).post<FileUploadResponses, FileUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYn = <ThrowOnError extends boolean = false>(options: Options<UpdateFileTempSaveYnData, ThrowOnError>): RequestResult<UpdateFileTempSaveYnResponses, UpdateFileTempSaveYnErrors, ThrowOnError> => (options.client ?? client).put<UpdateFileTempSaveYnResponses, UpdateFileTempSaveYnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 복사
 */
export const fileCopy = <ThrowOnError extends boolean = false>(options: Options<FileCopyData, ThrowOnError>): RequestResult<FileCopyResponses, FileCopyErrors, ThrowOnError> => (options.client ?? client).post<FileCopyResponses, FileCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3/copy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 복호화 다운로드
 */
export const fileDecryptionDownload = <ThrowOnError extends boolean = false>(options: Options<FileDecryptionDownloadData, ThrowOnError>): RequestResult<FileDecryptionDownloadResponses, FileDecryptionDownloadErrors, ThrowOnError> => (options.client ?? client).get<FileDecryptionDownloadResponses, FileDecryptionDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3/decryption',
    ...options
});

/**
 * 파일 재 업로드
 */
export const fileReUpload = <ThrowOnError extends boolean = false>(options?: Options<FileReUploadData, ThrowOnError>): RequestResult<FileReUploadResponses, FileReUploadErrors, ThrowOnError> => (options?.client ?? client).post<FileReUploadResponses, FileReUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3/re',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * 파일 이름 변경
 */
export const fileRename = <ThrowOnError extends boolean = false>(options: Options<FileRenameData, ThrowOnError>): RequestResult<FileRenameResponses, FileRenameErrors, ThrowOnError> => (options.client ?? client).put<FileRenameResponses, FileRenameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/s3/rename',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 투어 조회수/스크랩 정보 조회 (로그인)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedback = <ThrowOnError extends boolean = false>(options: Options<FindTourFeedbackData, ThrowOnError>): RequestResult<FindTourFeedbackResponses, FindTourFeedbackErrors, ThrowOnError> => (options.client ?? client).get<FindTourFeedbackResponses, FindTourFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/tour/feedback/{tourId}',
    ...options
});

/**
 * 웰로 앱 푸시 목록 조회
 */
export const getWebWelloAppPushList = <ThrowOnError extends boolean = false>(options: Options<GetWebWelloAppPushListData, ThrowOnError>): RequestResult<GetWebWelloAppPushListResponses, GetWebWelloAppPushListErrors, ThrowOnError> => (options.client ?? client).get<GetWebWelloAppPushListResponses, GetWebWelloAppPushListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-app-push',
    ...options
});

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushRead = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushReadData, ThrowOnError>): RequestResult<UpdateWelloAppPushReadResponses, UpdateWelloAppPushReadErrors, ThrowOnError> => (options.client ?? client).put<UpdateWelloAppPushReadResponses, UpdateWelloAppPushReadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-app-push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 댓글 목록 조회
 */
export const getWelloCommentList = <ThrowOnError extends boolean = false>(options: Options<GetWelloCommentListData, ThrowOnError>): RequestResult<GetWelloCommentListResponses, GetWelloCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetWelloCommentListResponses, GetWelloCommentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment',
    ...options
});

/**
 * 웰로 댓글 등록
 */
export const saveWelloComment = <ThrowOnError extends boolean = false>(options: Options<SaveWelloCommentData, ThrowOnError>): RequestResult<SaveWelloCommentResponses, SaveWelloCommentErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloCommentResponses, SaveWelloCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 댓글 신고 등록
 */
export const saveWelloCommentReport = <ThrowOnError extends boolean = false>(options: Options<SaveWelloCommentReportData, ThrowOnError>): RequestResult<SaveWelloCommentReportResponses, SaveWelloCommentReportErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloCommentReportResponses, SaveWelloCommentReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentList = <ThrowOnError extends boolean = false>(options?: Options<GetLiveWelloCommentListData, ThrowOnError>): RequestResult<GetLiveWelloCommentListResponses, GetLiveWelloCommentListErrors, ThrowOnError> => (options?.client ?? client).get<GetLiveWelloCommentListResponses, GetLiveWelloCommentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment/live',
    ...options
});

/**
 * 웰로 유저가 작성한 댓글 목록
 */
export const getMyWelloCommentList = <ThrowOnError extends boolean = false>(options: Options<GetMyWelloCommentListData, ThrowOnError>): RequestResult<GetMyWelloCommentListResponses, GetMyWelloCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetMyWelloCommentListResponses, GetMyWelloCommentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment/my',
    ...options
});

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentList = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListData, ThrowOnError>): RequestResult<GetMetaPolicyCommentListResponses, GetMetaPolicyCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetMetaPolicyCommentListResponses, GetMetaPolicyCommentListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment/{welloCommentId}',
    ...options
});

/**
 * 웰로 댓글 수정
 */
export const updateWelloComment = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloCommentData, ThrowOnError>): RequestResult<UpdateWelloCommentResponses, UpdateWelloCommentErrors, ThrowOnError> => (options.client ?? client).put<UpdateWelloCommentResponses, UpdateWelloCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment/{welloCommentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 댓글 삭제
 */
export const deleteWelloComment = <ThrowOnError extends boolean = false>(options: Options<DeleteWelloCommentData, ThrowOnError>): RequestResult<DeleteWelloCommentResponses, DeleteWelloCommentErrors, ThrowOnError> => (options.client ?? client).put<DeleteWelloCommentResponses, DeleteWelloCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-comment/{welloCommentId}/delete',
    ...options
});

/**
 * 가입 유저용 웰로 디바이스 정보 저장
 */
export const saveWelloDeviceInfo = <ThrowOnError extends boolean = false>(options: Options<SaveWelloDeviceInfoData, ThrowOnError>): RequestResult<SaveWelloDeviceInfoResponses, SaveWelloDeviceInfoErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloDeviceInfoResponses, SaveWelloDeviceInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-device-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 좋아요 삭제
 */
export const deleteWelloLike = <ThrowOnError extends boolean = false>(options: Options<DeleteWelloLikeData, ThrowOnError>): RequestResult<DeleteWelloLikeResponses, DeleteWelloLikeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWelloLikeResponses, DeleteWelloLikeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-like',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 좋아요 등록
 */
export const saveWelloLike = <ThrowOnError extends boolean = false>(options: Options<SaveWelloLikeData, ThrowOnError>): RequestResult<SaveWelloLikeResponses, SaveWelloLikeErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloLikeResponses, SaveWelloLikeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-like',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 내가 좋아요한 글 목록
 */
export const getListLikeContents = <ThrowOnError extends boolean = false>(options: Options<GetListLikeContentsData, ThrowOnError>): RequestResult<GetListLikeContentsResponses, GetListLikeContentsErrors, ThrowOnError> => (options.client ?? client).get<GetListLikeContentsResponses, GetListLikeContentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-like/my',
    ...options
});

/**
 * 내가 좋아요한 글 유형 목록
 */
export const getListLikeContentsType = <ThrowOnError extends boolean = false>(options?: Options<GetListLikeContentsTypeData, ThrowOnError>): RequestResult<GetListLikeContentsTypeResponses, GetListLikeContentsTypeErrors, ThrowOnError> => (options?.client ?? client).get<GetListLikeContentsTypeResponses, GetListLikeContentsTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-like/my/type',
    ...options
});

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const authReverseGeocoding = <ThrowOnError extends boolean = false>(options: Options<AuthReverseGeocodingData, ThrowOnError>): RequestResult<AuthReverseGeocodingResponses, AuthReverseGeocodingErrors, ThrowOnError> => (options.client ?? client).get<AuthReverseGeocodingResponses, AuthReverseGeocodingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-policy-code/reverse-geocoding',
    ...options
});

/**
 * 웰로 회원 트래킹 정보 저장
 */
export const saveWelloTracking = <ThrowOnError extends boolean = false>(options: Options<SaveWelloTrackingData, ThrowOnError>): RequestResult<SaveWelloTrackingResponses, SaveWelloTrackingErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloTrackingResponses, SaveWelloTrackingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-track',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 금칙어 목록 조회
 *
 * 등록된 금칙어를 최근 등록순으로 반환합니다. 삭제 API에 쓸 blocklistId를 여기서 확인합니다.
 */
export const findBlocklist = <ThrowOnError extends boolean = false>(options: Options<FindBlocklistData, ThrowOnError>): RequestResult<FindBlocklistResponses, FindBlocklistErrors, ThrowOnError> => (options.client ?? client).get<FindBlocklistResponses, FindBlocklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-trend-monitor/blocklist',
    ...options
});

/**
 * 금칙어 등록
 *
 * 키워드를 금칙어로 등록합니다(비밀번호는 body의 password). 서버가 집계와 같은 규칙으로 정규화해 저장하며, 이미 등록된 키워드면 활성화·사유 갱신만 합니다(중복 요청 안전). 다음 매시 :30 배치부터 순위에서 제외됩니다.
 */
export const saveBlocklist = <ThrowOnError extends boolean = false>(options: Options<SaveBlocklistData, ThrowOnError>): RequestResult<SaveBlocklistResponses, SaveBlocklistErrors, ThrowOnError> => (options.client ?? client).post<SaveBlocklistResponses, SaveBlocklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-trend-monitor/blocklist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 금칙어 삭제
 *
 * blocklistId로 금칙어를 삭제합니다. 목록 조회 API에서 ID를 확인하세요. 다음 매시 :30 배치부터 해당 키워드가 다시 순위에 오를 수 있습니다.
 */
export const deleteBlocklist = <ThrowOnError extends boolean = false>(options: Options<DeleteBlocklistData, ThrowOnError>): RequestResult<DeleteBlocklistResponses, DeleteBlocklistErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBlocklistResponses, DeleteBlocklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v2/auth/wello-trend-monitor/blocklist/{blocklistId}',
    ...options
});

/**
 * 통합 대상 계정 조회
 *
 * 로그인 회원과 동일 본인확인 원문을 가진 다른 계정 목록을 반환한다.
 */
export const candidates = <ThrowOnError extends boolean = false>(options?: Options<CandidatesData, ThrowOnError>): RequestResult<CandidatesResponses, CandidatesErrors, ThrowOnError> => (options?.client ?? client).get<CandidatesResponses, CandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v3/auth/account-integration/candidates',
    ...options
});

/**
 * 계정통합 실행
 *
 * survivorMemberCode(선택)를 생존 계정으로, loserMemberCodes 계정들을 병합한다. 생략 시 동일인 계정 중 유일한 웰로 계정이 생존 계정. 생존 계정은 항상 웰로 계정이어야 한다(KB 전용 계정 불가). 병합 커밋 후 생존 계정으로 토큰을 재발급해 응답의 token으로 반환한다(로그아웃 불필요).
 */
export const merge = <ThrowOnError extends boolean = false>(options: Options<MergeData, ThrowOnError>): RequestResult<MergeResponses, MergeErrors, ThrowOnError> => (options.client ?? client).post<MergeResponses, MergeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v3/auth/account-integration/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 배송 조회 v3 (provider 통합)
 *
 * 배송 추적 조회 (provider 통합).
 *
 * <p>tracking provider(GOODSFLOW/LOGIS_TRACKING)에 따라 적절한 API로 배송 상태를 조회한다.</p>
 */
export const getDeliveryTracking = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryTrackingData, ThrowOnError>): RequestResult<GetDeliveryTrackingResponses, GetDeliveryTrackingErrors, ThrowOnError> => (options.client ?? client).get<GetDeliveryTrackingResponses, GetDeliveryTrackingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/wello/v3/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking',
    ...options
});
